/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Blueprint: Internal API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

import type {
  AddNewSearchResponseDto,
  ApiExceptionDto,
  AppointmentDto,
  AssignCheckInBodyDto,
  AssignCheckInDto,
  AssignedCheckInDto,
  AssistEnrollDto,
  BulkCreateClinicianDto,
  BulkUploadResponseDto,
  CalendarResponseDto,
  CancelAppointmentDto,
  CancelPlusPlanFreeTrialDto,
  ChangePlanBodyDto,
  ChangePlanPreviewResponseDto,
  ChangePlanRequestDto,
  ChangePlanResponseDto,
  CheckInBodyDto,
  CheckInDtoV2,
  CheckStripeConnectOnboardingStatusResponseDto,
  CheckinsControllerV1GetAllCheckInsParams,
  ClearTemplateMemoryDto,
  ClientListDto,
  ClientTelehealthUrlDto,
  ClinicClientNotificationPreferencesDto,
  ClinicControllerChangePlanPreviewParams,
  ClinicControllerGetAssignedCheckInsParams,
  ClinicControllerGetCheckInsParams,
  ClinicControllerGetClientListParams,
  ClinicControllerGetDocumentReferencesParams,
  ClinicControllerSearchClinicsParams,
  ClinicLocationDto,
  ClinicSearchResultListDto,
  ClinicTimezoneDto,
  ClinicianDto,
  ClinicianLicenseDto,
  ClinicianLicenseListDto,
  ClinicianSchedulingControllerGetAddNewSuggestionsParams,
  ClinicianSchedulingControllerGetClinicianScheduleParams,
  CompleteUploadDto,
  CompletedSessionDto,
  CompletedSessionDtoV2,
  ConsentSettingDTO,
  CreateAppointmentWithNotificationDto,
  CreateClinicianLicenseDto,
  CreateCustomProgressNoteTemplateDTO,
  CreateSampleSessionDto,
  CreateStripeConnectAccountLinkRequestDto,
  CreateStripeConnectAccountLinkResponseDto,
  CreateStripeConnectAccountResponseDto,
  CurrentPlanResponseDto,
  CustomProgressNoteTemplateDTO,
  DefaultServiceTypeResponse,
  DischargeSummaryDto,
  DocumentReferenceDto,
  EditDocumentReferenceDto,
  ExternalCalendarDto,
  ExternalCalendarResponseDto,
  IcsCalendarLinkResponseDto,
  Intervention,
  InterventionsControllerV1GetAllInterventionsParams,
  InviteEmailBodyDTO,
  InviteLinkResponseDTO,
  InviteStatusResponseDTO,
  InvoiceDto,
  MarkSessionCompleteBodyDto,
  MarkSessionCompleteBodyDtoV2,
  NextAppointmentDateResponseDto,
  OnboardingSurveyDto,
  OrganizationControllerGetOrganizationPreferences200,
  OutboundEhrSettingsDTO,
  PatchConsentSettingDTO,
  PatchDischargeSummaryDto,
  PatchNoteDto,
  PatientCheckInScoresDto,
  PatientConsentDto,
  PatientControllerGetConsentParams,
  PatientControllerGetPatientsParams,
  PatientDto,
  PatientIntakeConsentResultsDto,
  PatientIntakeQuestionnaireResultsDto,
  PatientIntakeStatusDto,
  PatientInterventionDto,
  PatientInterventionWithInterventionDto,
  PatientInterventionWithResponsesDto,
  PatientInterventionsControllerGetAllPatientInterventionsParams,
  PaymentMethodDto,
  PlanOptionDto,
  PostPatientInterventionDto,
  ProgressNoteTemplateMemoryControllerFindByNoteTypeParams,
  ProgressNoteTemplateMemoryResponseDto,
  PromotionDiscountDto,
  PurchaseSessionCreditsRequestDto,
  PutPatientInterventionDto,
  ReferralRewardStatusResponseDTO,
  ReferralTierStatusResponseDTO,
  SampleSessionDto,
  SaveForLaterBodyDto,
  SavedForLaterInterventionDto,
  ScheduleResponseDto,
  SelectVersionDto,
  SendIntakeDocumentsRequestDto,
  SendIntakeDocumentsResponseDto,
  ServiceTypeControllerGetDefaultServiceTypeParams,
  ServiceTypesResponse,
  SessionControllerGetDemoSuggestedContentParams,
  SessionControllerGetSessionPrepParams,
  SessionControllerGetSessionsListParams,
  SessionCreateBodyDto,
  SessionCreditDTO,
  SessionCreditsPaymentMethodRequestDto,
  SessionCreditsPaymentMethodResponseDto,
  SessionDebugDto,
  SessionDraftDto,
  SessionDto,
  SessionFromUploadedAudioBodyDto,
  SessionFromUploadedAudioBodyDtoV2,
  SessionListResponseDto,
  SessionPatchDtoV2,
  SessionPlannedInterventionsBodyDto,
  SessionPrepDto,
  SessionProgressNoteDto,
  SessionProgressNotesDto,
  SessionPsychotherapyNoteBodyDto,
  SessionRecapResponse,
  SessionUsageInvoiceDTO,
  SetReminderDto,
  StartInterventionsBodyDto,
  StartUploadDto,
  StripeInvoiceDto,
  SubmitFeedbackDto,
  SuggestedContentDTO,
  TelehealthMeetingTokenDto,
  TrackEventDto,
  UnseenReferralRewardResponseDTO,
  UpdateAppointmentWithNotificationDto,
  UpdateAutoReplenishDto,
  UpdateBillingEmailDto,
  UpdateCheckInNotificationDto,
  UpdateClinicianDto,
  UpdateClinicianLicenseDto,
  UpdateInvoiceDto,
  UploadFileBodyDto,
  ValidateEmailDto,
  ValidatePromotionCodeDto,
  ValidatePromotionCodeResponseDto
} from './models';

import { hellojoyApiInstance } from '../../axios-instance';
import type { ErrorType } from '../../axios-instance';




export const bulkUploadControllerBulkUploadClinicians = (
    bulkCreateClinicianDto: BulkCreateClinicianDto[],
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<BulkUploadResponseDto>(
      {url: `/v1/clinician-api/bulk-upload/clinicians`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkCreateClinicianDto, signal
    },
      );
    }
  


export const getBulkUploadControllerBulkUploadCliniciansMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUploadControllerBulkUploadClinicians>>, TError,{data: BulkCreateClinicianDto[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkUploadControllerBulkUploadClinicians>>, TError,{data: BulkCreateClinicianDto[]}, TContext> => {

const mutationKey = ['bulkUploadControllerBulkUploadClinicians'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUploadControllerBulkUploadClinicians>>, {data: BulkCreateClinicianDto[]}> = (props) => {
          const {data} = props ?? {};

          return  bulkUploadControllerBulkUploadClinicians(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUploadControllerBulkUploadCliniciansMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUploadControllerBulkUploadClinicians>>>
    export type BulkUploadControllerBulkUploadCliniciansMutationBody = BulkCreateClinicianDto[]
    export type BulkUploadControllerBulkUploadCliniciansMutationError = ErrorType<void>

    export const useBulkUploadControllerBulkUploadClinicians = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUploadControllerBulkUploadClinicians>>, TError,{data: BulkCreateClinicianDto[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUploadControllerBulkUploadClinicians>>,
        TError,
        {data: BulkCreateClinicianDto[]},
        TContext
      > => {

      const mutationOptions = getBulkUploadControllerBulkUploadCliniciansMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerGetClientList = (
    clinicId: string,
    params?: ClinicControllerGetClientListParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClientListDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/client-list`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicControllerGetClientListQueryKey = (clinicId: string,
    params?: ClinicControllerGetClientListParams,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/client-list`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicControllerGetClientListQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetClientList>>, TError = ErrorType<void>>(clinicId: string,
    params?: ClinicControllerGetClientListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClientList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetClientListQueryKey(clinicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetClientList>>> = ({ signal }) => clinicControllerGetClientList(clinicId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClientList>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetClientListQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetClientList>>>
export type ClinicControllerGetClientListQueryError = ErrorType<void>



export function useClinicControllerGetClientList<TData = Awaited<ReturnType<typeof clinicControllerGetClientList>>, TError = ErrorType<void>>(
 clinicId: string,
    params?: ClinicControllerGetClientListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClientList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetClientListQueryOptions(clinicId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerGetCheckIns = (
    clinicId: string,
    params?: ClinicControllerGetCheckInsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckInDtoV2[]>(
      {url: `/v1/clinician-api/clinic/${clinicId}/library/check-ins`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicControllerGetCheckInsQueryKey = (clinicId: string,
    params?: ClinicControllerGetCheckInsParams,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/library/check-ins`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicControllerGetCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetCheckIns>>, TError = ErrorType<void>>(clinicId: string,
    params?: ClinicControllerGetCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetCheckIns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetCheckInsQueryKey(clinicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetCheckIns>>> = ({ signal }) => clinicControllerGetCheckIns(clinicId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetCheckIns>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetCheckIns>>>
export type ClinicControllerGetCheckInsQueryError = ErrorType<void>



export function useClinicControllerGetCheckIns<TData = Awaited<ReturnType<typeof clinicControllerGetCheckIns>>, TError = ErrorType<void>>(
 clinicId: string,
    params?: ClinicControllerGetCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetCheckIns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetCheckInsQueryOptions(clinicId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerGetAssignedCheckIns = (
    clinicId: string,
    params?: ClinicControllerGetAssignedCheckInsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckInDtoV2[]>(
      {url: `/v1/clinician-api/clinic/${clinicId}/library/check-ins/assigned`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicControllerGetAssignedCheckInsQueryKey = (clinicId: string,
    params?: ClinicControllerGetAssignedCheckInsParams,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/library/check-ins/assigned`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicControllerGetAssignedCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>, TError = ErrorType<void>>(clinicId: string,
    params?: ClinicControllerGetAssignedCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetAssignedCheckInsQueryKey(clinicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>> = ({ signal }) => clinicControllerGetAssignedCheckIns(clinicId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetAssignedCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>>
export type ClinicControllerGetAssignedCheckInsQueryError = ErrorType<void>



export function useClinicControllerGetAssignedCheckIns<TData = Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>, TError = ErrorType<void>>(
 clinicId: string,
    params?: ClinicControllerGetAssignedCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetAssignedCheckIns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetAssignedCheckInsQueryOptions(clinicId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerToggleCheckInDefault = (
    clinicId: string,
    checkInId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/library/check-ins/${checkInId}/toggle-default`, method: 'PUT'
    },
      );
    }
  


export const getClinicControllerToggleCheckInDefaultMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerToggleCheckInDefault>>, TError,{clinicId: string;checkInId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerToggleCheckInDefault>>, TError,{clinicId: string;checkInId: string}, TContext> => {

const mutationKey = ['clinicControllerToggleCheckInDefault'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerToggleCheckInDefault>>, {clinicId: string;checkInId: string}> = (props) => {
          const {clinicId,checkInId} = props ?? {};

          return  clinicControllerToggleCheckInDefault(clinicId,checkInId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerToggleCheckInDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerToggleCheckInDefault>>>
    
    export type ClinicControllerToggleCheckInDefaultMutationError = ErrorType<void>

    export const useClinicControllerToggleCheckInDefault = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerToggleCheckInDefault>>, TError,{clinicId: string;checkInId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerToggleCheckInDefault>>,
        TError,
        {clinicId: string;checkInId: string},
        TContext
      > => {

      const mutationOptions = getClinicControllerToggleCheckInDefaultMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerAssignCheckIn = (
    clinicId: string,
    assignCheckInBodyDto: AssignCheckInBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/library/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignCheckInBodyDto, signal
    },
      );
    }
  


export const getClinicControllerAssignCheckInMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerAssignCheckIn>>, TError,{clinicId: string;data: AssignCheckInBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerAssignCheckIn>>, TError,{clinicId: string;data: AssignCheckInBodyDto}, TContext> => {

const mutationKey = ['clinicControllerAssignCheckIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerAssignCheckIn>>, {clinicId: string;data: AssignCheckInBodyDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerAssignCheckIn(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerAssignCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerAssignCheckIn>>>
    export type ClinicControllerAssignCheckInMutationBody = AssignCheckInBodyDto
    export type ClinicControllerAssignCheckInMutationError = ErrorType<void>

    export const useClinicControllerAssignCheckIn = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerAssignCheckIn>>, TError,{clinicId: string;data: AssignCheckInBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerAssignCheckIn>>,
        TError,
        {clinicId: string;data: AssignCheckInBodyDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerAssignCheckInMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerUnassignCheckIn = (
    clinicId: string,
    assignCheckInBodyDto: AssignCheckInBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/library/unassign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignCheckInBodyDto, signal
    },
      );
    }
  


export const getClinicControllerUnassignCheckInMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUnassignCheckIn>>, TError,{clinicId: string;data: AssignCheckInBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUnassignCheckIn>>, TError,{clinicId: string;data: AssignCheckInBodyDto}, TContext> => {

const mutationKey = ['clinicControllerUnassignCheckIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerUnassignCheckIn>>, {clinicId: string;data: AssignCheckInBodyDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerUnassignCheckIn(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerUnassignCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerUnassignCheckIn>>>
    export type ClinicControllerUnassignCheckInMutationBody = AssignCheckInBodyDto
    export type ClinicControllerUnassignCheckInMutationError = ErrorType<void>

    export const useClinicControllerUnassignCheckIn = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUnassignCheckIn>>, TError,{clinicId: string;data: AssignCheckInBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerUnassignCheckIn>>,
        TError,
        {clinicId: string;data: AssignCheckInBodyDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerUnassignCheckInMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerGetPaymentMethods = (
    clinicId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PaymentMethodDto[]>(
      {url: `/v1/clinician-api/clinic/${clinicId}/payment-methods`, method: 'GET', signal
    },
      );
    }
  

export const getClinicControllerGetPaymentMethodsQueryKey = (clinicId: string,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/payment-methods`] as const;
    }

    
export const getClinicControllerGetPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>, TError = ErrorType<void>>(clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetPaymentMethodsQueryKey(clinicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>> = ({ signal }) => clinicControllerGetPaymentMethods(clinicId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>>
export type ClinicControllerGetPaymentMethodsQueryError = ErrorType<void>



export function useClinicControllerGetPaymentMethods<TData = Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>, TError = ErrorType<void>>(
 clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPaymentMethods>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetPaymentMethodsQueryOptions(clinicId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerGetPlanOptions = (
    clinicId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PlanOptionDto[]>(
      {url: `/v1/clinician-api/clinic/${clinicId}/plan-options`, method: 'GET', signal
    },
      );
    }
  

export const getClinicControllerGetPlanOptionsQueryKey = (clinicId: string,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/plan-options`] as const;
    }

    
export const getClinicControllerGetPlanOptionsQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>, TError = ErrorType<void>>(clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetPlanOptionsQueryKey(clinicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>> = ({ signal }) => clinicControllerGetPlanOptions(clinicId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetPlanOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>>
export type ClinicControllerGetPlanOptionsQueryError = ErrorType<void>



export function useClinicControllerGetPlanOptions<TData = Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>, TError = ErrorType<void>>(
 clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPlanOptions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetPlanOptionsQueryOptions(clinicId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerGetCurrentPlan = (
    clinicId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CurrentPlanResponseDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/current-plan`, method: 'GET', signal
    },
      );
    }
  

export const getClinicControllerGetCurrentPlanQueryKey = (clinicId: string,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/current-plan`] as const;
    }

    
export const getClinicControllerGetCurrentPlanQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>, TError = ErrorType<void>>(clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetCurrentPlanQueryKey(clinicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>> = ({ signal }) => clinicControllerGetCurrentPlan(clinicId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetCurrentPlanQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>>
export type ClinicControllerGetCurrentPlanQueryError = ErrorType<void>



export function useClinicControllerGetCurrentPlan<TData = Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>, TError = ErrorType<void>>(
 clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetCurrentPlan>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetCurrentPlanQueryOptions(clinicId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerChangePlanPreview = (
    clinicId: string,
    params: ClinicControllerChangePlanPreviewParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ChangePlanPreviewResponseDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/change-plan-preview`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicControllerChangePlanPreviewQueryKey = (clinicId: string,
    params: ClinicControllerChangePlanPreviewParams,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/change-plan-preview`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicControllerChangePlanPreviewQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>, TError = ErrorType<void>>(clinicId: string,
    params: ClinicControllerChangePlanPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerChangePlanPreviewQueryKey(clinicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>> = ({ signal }) => clinicControllerChangePlanPreview(clinicId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerChangePlanPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>>
export type ClinicControllerChangePlanPreviewQueryError = ErrorType<void>



export function useClinicControllerChangePlanPreview<TData = Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>, TError = ErrorType<void>>(
 clinicId: string,
    params: ClinicControllerChangePlanPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerChangePlanPreview>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerChangePlanPreviewQueryOptions(clinicId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerChangePlan = (
    clinicId: string,
    changePlanBodyDto: ChangePlanBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/change-plan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePlanBodyDto, signal
    },
      );
    }
  


export const getClinicControllerChangePlanMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerChangePlan>>, TError,{clinicId: string;data: ChangePlanBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerChangePlan>>, TError,{clinicId: string;data: ChangePlanBodyDto}, TContext> => {

const mutationKey = ['clinicControllerChangePlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerChangePlan>>, {clinicId: string;data: ChangePlanBodyDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerChangePlan(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerChangePlanMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerChangePlan>>>
    export type ClinicControllerChangePlanMutationBody = ChangePlanBodyDto
    export type ClinicControllerChangePlanMutationError = ErrorType<void>

    export const useClinicControllerChangePlan = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerChangePlan>>, TError,{clinicId: string;data: ChangePlanBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerChangePlan>>,
        TError,
        {clinicId: string;data: ChangePlanBodyDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerChangePlanMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerCancelPlusPlanFreeTrial = (
    clinicId: string,
    cancelPlusPlanFreeTrialDto: CancelPlusPlanFreeTrialDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/cancel-plus-plan-free-trial`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelPlusPlanFreeTrialDto, signal
    },
      );
    }
  


export const getClinicControllerCancelPlusPlanFreeTrialMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerCancelPlusPlanFreeTrial>>, TError,{clinicId: string;data: CancelPlusPlanFreeTrialDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerCancelPlusPlanFreeTrial>>, TError,{clinicId: string;data: CancelPlusPlanFreeTrialDto}, TContext> => {

const mutationKey = ['clinicControllerCancelPlusPlanFreeTrial'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerCancelPlusPlanFreeTrial>>, {clinicId: string;data: CancelPlusPlanFreeTrialDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerCancelPlusPlanFreeTrial(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerCancelPlusPlanFreeTrialMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerCancelPlusPlanFreeTrial>>>
    export type ClinicControllerCancelPlusPlanFreeTrialMutationBody = CancelPlusPlanFreeTrialDto
    export type ClinicControllerCancelPlusPlanFreeTrialMutationError = ErrorType<void>

    export const useClinicControllerCancelPlusPlanFreeTrial = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerCancelPlusPlanFreeTrial>>, TError,{clinicId: string;data: CancelPlusPlanFreeTrialDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerCancelPlusPlanFreeTrial>>,
        TError,
        {clinicId: string;data: CancelPlusPlanFreeTrialDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerCancelPlusPlanFreeTrialMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerStartPlusPlanFreeTrial = (
    clinicId: string,
    cancelPlusPlanFreeTrialDto: CancelPlusPlanFreeTrialDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/start-plus-plan-free-trial`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelPlusPlanFreeTrialDto, signal
    },
      );
    }
  


export const getClinicControllerStartPlusPlanFreeTrialMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerStartPlusPlanFreeTrial>>, TError,{clinicId: string;data: CancelPlusPlanFreeTrialDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerStartPlusPlanFreeTrial>>, TError,{clinicId: string;data: CancelPlusPlanFreeTrialDto}, TContext> => {

const mutationKey = ['clinicControllerStartPlusPlanFreeTrial'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerStartPlusPlanFreeTrial>>, {clinicId: string;data: CancelPlusPlanFreeTrialDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerStartPlusPlanFreeTrial(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerStartPlusPlanFreeTrialMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerStartPlusPlanFreeTrial>>>
    export type ClinicControllerStartPlusPlanFreeTrialMutationBody = CancelPlusPlanFreeTrialDto
    export type ClinicControllerStartPlusPlanFreeTrialMutationError = ErrorType<void>

    export const useClinicControllerStartPlusPlanFreeTrial = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerStartPlusPlanFreeTrial>>, TError,{clinicId: string;data: CancelPlusPlanFreeTrialDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerStartPlusPlanFreeTrial>>,
        TError,
        {clinicId: string;data: CancelPlusPlanFreeTrialDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerStartPlusPlanFreeTrialMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerGetPromotionDiscount = (
    clinicId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PromotionDiscountDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/promotion-discount`, method: 'GET', signal
    },
      );
    }
  

export const getClinicControllerGetPromotionDiscountQueryKey = (clinicId: string,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/promotion-discount`] as const;
    }

    
export const getClinicControllerGetPromotionDiscountQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>, TError = ErrorType<void>>(clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetPromotionDiscountQueryKey(clinicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>> = ({ signal }) => clinicControllerGetPromotionDiscount(clinicId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetPromotionDiscountQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>>
export type ClinicControllerGetPromotionDiscountQueryError = ErrorType<void>



export function useClinicControllerGetPromotionDiscount<TData = Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>, TError = ErrorType<void>>(
 clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetPromotionDiscount>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetPromotionDiscountQueryOptions(clinicId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerSearchClinics = (
    params: ClinicControllerSearchClinicsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicSearchResultListDto>(
      {url: `/v1/clinician-api/clinic/search`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicControllerSearchClinicsQueryKey = (params: ClinicControllerSearchClinicsParams,) => {
    return [`/v1/clinician-api/clinic/search`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicControllerSearchClinicsQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerSearchClinics>>, TError = ErrorType<void>>(params: ClinicControllerSearchClinicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerSearchClinics>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerSearchClinicsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerSearchClinics>>> = ({ signal }) => clinicControllerSearchClinics(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerSearchClinics>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerSearchClinicsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerSearchClinics>>>
export type ClinicControllerSearchClinicsQueryError = ErrorType<void>



export function useClinicControllerSearchClinics<TData = Awaited<ReturnType<typeof clinicControllerSearchClinics>>, TError = ErrorType<void>>(
 params: ClinicControllerSearchClinicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerSearchClinics>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerSearchClinicsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerGetClientNotificationPreferences = (
    clinicId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicClientNotificationPreferencesDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/client-notification-preferences`, method: 'GET', signal
    },
      );
    }
  

export const getClinicControllerGetClientNotificationPreferencesQueryKey = (clinicId: string,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/client-notification-preferences`] as const;
    }

    
export const getClinicControllerGetClientNotificationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>, TError = ErrorType<void>>(clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetClientNotificationPreferencesQueryKey(clinicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>> = ({ signal }) => clinicControllerGetClientNotificationPreferences(clinicId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetClientNotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>>
export type ClinicControllerGetClientNotificationPreferencesQueryError = ErrorType<void>



export function useClinicControllerGetClientNotificationPreferences<TData = Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>, TError = ErrorType<void>>(
 clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClientNotificationPreferences>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetClientNotificationPreferencesQueryOptions(clinicId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerUpdateClientNotificationPreferences = (
    clinicId: string,
    clinicClientNotificationPreferencesDto: ClinicClientNotificationPreferencesDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/client-notification-preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: clinicClientNotificationPreferencesDto
    },
      );
    }
  


export const getClinicControllerUpdateClientNotificationPreferencesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClientNotificationPreferences>>, TError,{clinicId: string;data: ClinicClientNotificationPreferencesDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClientNotificationPreferences>>, TError,{clinicId: string;data: ClinicClientNotificationPreferencesDto}, TContext> => {

const mutationKey = ['clinicControllerUpdateClientNotificationPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerUpdateClientNotificationPreferences>>, {clinicId: string;data: ClinicClientNotificationPreferencesDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerUpdateClientNotificationPreferences(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerUpdateClientNotificationPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerUpdateClientNotificationPreferences>>>
    export type ClinicControllerUpdateClientNotificationPreferencesMutationBody = ClinicClientNotificationPreferencesDto
    export type ClinicControllerUpdateClientNotificationPreferencesMutationError = ErrorType<void>

    export const useClinicControllerUpdateClientNotificationPreferences = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClientNotificationPreferences>>, TError,{clinicId: string;data: ClinicClientNotificationPreferencesDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerUpdateClientNotificationPreferences>>,
        TError,
        {clinicId: string;data: ClinicClientNotificationPreferencesDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerUpdateClientNotificationPreferencesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerUpdateClinicLocation = (
    clinicId: string,
    clinicLocationDto: ClinicLocationDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/location`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: clinicLocationDto
    },
      );
    }
  


export const getClinicControllerUpdateClinicLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClinicLocation>>, TError,{clinicId: string;data: ClinicLocationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClinicLocation>>, TError,{clinicId: string;data: ClinicLocationDto}, TContext> => {

const mutationKey = ['clinicControllerUpdateClinicLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerUpdateClinicLocation>>, {clinicId: string;data: ClinicLocationDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerUpdateClinicLocation(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerUpdateClinicLocationMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerUpdateClinicLocation>>>
    export type ClinicControllerUpdateClinicLocationMutationBody = ClinicLocationDto
    export type ClinicControllerUpdateClinicLocationMutationError = ErrorType<void>

    export const useClinicControllerUpdateClinicLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClinicLocation>>, TError,{clinicId: string;data: ClinicLocationDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerUpdateClinicLocation>>,
        TError,
        {clinicId: string;data: ClinicLocationDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerUpdateClinicLocationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerGetClinicLocation = (
    clinicId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicLocationDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/location`, method: 'GET', signal
    },
      );
    }
  

export const getClinicControllerGetClinicLocationQueryKey = (clinicId: string,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/location`] as const;
    }

    
export const getClinicControllerGetClinicLocationQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>, TError = ErrorType<void>>(clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetClinicLocationQueryKey(clinicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>> = ({ signal }) => clinicControllerGetClinicLocation(clinicId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetClinicLocationQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>>
export type ClinicControllerGetClinicLocationQueryError = ErrorType<void>



export function useClinicControllerGetClinicLocation<TData = Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>, TError = ErrorType<void>>(
 clinicId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetClinicLocation>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetClinicLocationQueryOptions(clinicId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerDeleteClinicLocation = (
    clinicId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/location`, method: 'DELETE'
    },
      );
    }
  


export const getClinicControllerDeleteClinicLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerDeleteClinicLocation>>, TError,{clinicId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerDeleteClinicLocation>>, TError,{clinicId: string}, TContext> => {

const mutationKey = ['clinicControllerDeleteClinicLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerDeleteClinicLocation>>, {clinicId: string}> = (props) => {
          const {clinicId} = props ?? {};

          return  clinicControllerDeleteClinicLocation(clinicId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerDeleteClinicLocationMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerDeleteClinicLocation>>>
    
    export type ClinicControllerDeleteClinicLocationMutationError = ErrorType<void>

    export const useClinicControllerDeleteClinicLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerDeleteClinicLocation>>, TError,{clinicId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerDeleteClinicLocation>>,
        TError,
        {clinicId: string},
        TContext
      > => {

      const mutationOptions = getClinicControllerDeleteClinicLocationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerUpdateClinicTimezone = (
    clinicId: string,
    clinicTimezoneDto: ClinicTimezoneDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/timezone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: clinicTimezoneDto
    },
      );
    }
  


export const getClinicControllerUpdateClinicTimezoneMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClinicTimezone>>, TError,{clinicId: string;data: ClinicTimezoneDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClinicTimezone>>, TError,{clinicId: string;data: ClinicTimezoneDto}, TContext> => {

const mutationKey = ['clinicControllerUpdateClinicTimezone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerUpdateClinicTimezone>>, {clinicId: string;data: ClinicTimezoneDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerUpdateClinicTimezone(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerUpdateClinicTimezoneMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerUpdateClinicTimezone>>>
    export type ClinicControllerUpdateClinicTimezoneMutationBody = ClinicTimezoneDto
    export type ClinicControllerUpdateClinicTimezoneMutationError = ErrorType<void>

    export const useClinicControllerUpdateClinicTimezone = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerUpdateClinicTimezone>>, TError,{clinicId: string;data: ClinicTimezoneDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerUpdateClinicTimezone>>,
        TError,
        {clinicId: string;data: ClinicTimezoneDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerUpdateClinicTimezoneMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerGetDocumentReferences = (
    clinicId: string,
    params?: ClinicControllerGetDocumentReferencesParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<DocumentReferenceDto[]>(
      {url: `/v1/clinician-api/clinic/${clinicId}/document-references`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicControllerGetDocumentReferencesQueryKey = (clinicId: string,
    params?: ClinicControllerGetDocumentReferencesParams,) => {
    return [`/v1/clinician-api/clinic/${clinicId}/document-references`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicControllerGetDocumentReferencesQueryOptions = <TData = Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>, TError = ErrorType<void>>(clinicId: string,
    params?: ClinicControllerGetDocumentReferencesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicControllerGetDocumentReferencesQueryKey(clinicId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>> = ({ signal }) => clinicControllerGetDocumentReferences(clinicId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicControllerGetDocumentReferencesQueryResult = NonNullable<Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>>
export type ClinicControllerGetDocumentReferencesQueryError = ErrorType<void>



export function useClinicControllerGetDocumentReferences<TData = Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>, TError = ErrorType<void>>(
 clinicId: string,
    params?: ClinicControllerGetDocumentReferencesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicControllerGetDocumentReferences>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicControllerGetDocumentReferencesQueryOptions(clinicId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicControllerArchiveDocumentReference = (
    clinicId: string,
    documentReferenceId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/document-references/${documentReferenceId}/archive`, method: 'PUT'
    },
      );
    }
  


export const getClinicControllerArchiveDocumentReferenceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerArchiveDocumentReference>>, TError,{clinicId: string;documentReferenceId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerArchiveDocumentReference>>, TError,{clinicId: string;documentReferenceId: string}, TContext> => {

const mutationKey = ['clinicControllerArchiveDocumentReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerArchiveDocumentReference>>, {clinicId: string;documentReferenceId: string}> = (props) => {
          const {clinicId,documentReferenceId} = props ?? {};

          return  clinicControllerArchiveDocumentReference(clinicId,documentReferenceId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerArchiveDocumentReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerArchiveDocumentReference>>>
    
    export type ClinicControllerArchiveDocumentReferenceMutationError = ErrorType<void>

    export const useClinicControllerArchiveDocumentReference = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerArchiveDocumentReference>>, TError,{clinicId: string;documentReferenceId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerArchiveDocumentReference>>,
        TError,
        {clinicId: string;documentReferenceId: string},
        TContext
      > => {

      const mutationOptions = getClinicControllerArchiveDocumentReferenceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerEditDocumentReference = (
    clinicId: string,
    documentReferenceId: string,
    editDocumentReferenceDto: EditDocumentReferenceDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/clinic/${clinicId}/document-references/${documentReferenceId}/edit`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: editDocumentReferenceDto
    },
      );
    }
  


export const getClinicControllerEditDocumentReferenceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerEditDocumentReference>>, TError,{clinicId: string;documentReferenceId: string;data: EditDocumentReferenceDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerEditDocumentReference>>, TError,{clinicId: string;documentReferenceId: string;data: EditDocumentReferenceDto}, TContext> => {

const mutationKey = ['clinicControllerEditDocumentReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerEditDocumentReference>>, {clinicId: string;documentReferenceId: string;data: EditDocumentReferenceDto}> = (props) => {
          const {clinicId,documentReferenceId,data} = props ?? {};

          return  clinicControllerEditDocumentReference(clinicId,documentReferenceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerEditDocumentReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerEditDocumentReference>>>
    export type ClinicControllerEditDocumentReferenceMutationBody = EditDocumentReferenceDto
    export type ClinicControllerEditDocumentReferenceMutationError = ErrorType<void>

    export const useClinicControllerEditDocumentReference = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerEditDocumentReference>>, TError,{clinicId: string;documentReferenceId: string;data: EditDocumentReferenceDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerEditDocumentReference>>,
        TError,
        {clinicId: string;documentReferenceId: string;data: EditDocumentReferenceDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerEditDocumentReferenceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicControllerValidatePromotionCode = (
    clinicId: string,
    validatePromotionCodeDto: ValidatePromotionCodeDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ValidatePromotionCodeResponseDto>(
      {url: `/v1/clinician-api/clinic/${clinicId}/validate-promotion-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validatePromotionCodeDto, signal
    },
      );
    }
  


export const getClinicControllerValidatePromotionCodeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerValidatePromotionCode>>, TError,{clinicId: string;data: ValidatePromotionCodeDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicControllerValidatePromotionCode>>, TError,{clinicId: string;data: ValidatePromotionCodeDto}, TContext> => {

const mutationKey = ['clinicControllerValidatePromotionCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicControllerValidatePromotionCode>>, {clinicId: string;data: ValidatePromotionCodeDto}> = (props) => {
          const {clinicId,data} = props ?? {};

          return  clinicControllerValidatePromotionCode(clinicId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicControllerValidatePromotionCodeMutationResult = NonNullable<Awaited<ReturnType<typeof clinicControllerValidatePromotionCode>>>
    export type ClinicControllerValidatePromotionCodeMutationBody = ValidatePromotionCodeDto
    export type ClinicControllerValidatePromotionCodeMutationError = ErrorType<void>

    export const useClinicControllerValidatePromotionCode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicControllerValidatePromotionCode>>, TError,{clinicId: string;data: ValidatePromotionCodeDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicControllerValidatePromotionCode>>,
        TError,
        {clinicId: string;data: ValidatePromotionCodeDto},
        TContext
      > => {

      const mutationOptions = getClinicControllerValidatePromotionCodeMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianControllerGetClinician = (
    clinicianId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicianDto>(
      {url: `/v1/clinician-api/clinician/${clinicianId}`, method: 'GET', signal
    },
      );
    }
  

export const getClinicianControllerGetClinicianQueryKey = (clinicianId: string,) => {
    return [`/v1/clinician-api/clinician/${clinicianId}`] as const;
    }

    
export const getClinicianControllerGetClinicianQueryOptions = <TData = Awaited<ReturnType<typeof clinicianControllerGetClinician>>, TError = ErrorType<ApiExceptionDto>>(clinicianId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianControllerGetClinician>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianControllerGetClinicianQueryKey(clinicianId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianControllerGetClinician>>> = ({ signal }) => clinicianControllerGetClinician(clinicianId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clinicianId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianControllerGetClinician>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianControllerGetClinicianQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianControllerGetClinician>>>
export type ClinicianControllerGetClinicianQueryError = ErrorType<ApiExceptionDto>



export function useClinicianControllerGetClinician<TData = Awaited<ReturnType<typeof clinicianControllerGetClinician>>, TError = ErrorType<ApiExceptionDto>>(
 clinicianId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianControllerGetClinician>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianControllerGetClinicianQueryOptions(clinicianId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianControllerUpdateClinician = (
    clinicianId: string,
    updateClinicianDto: UpdateClinicianDto,
 ) => {
      
      
      return hellojoyApiInstance<ClinicianDto>(
      {url: `/v1/clinician-api/clinician/${clinicianId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClinicianDto
    },
      );
    }
  


export const getClinicianControllerUpdateClinicianMutationOptions = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianControllerUpdateClinician>>, TError,{clinicianId: string;data: UpdateClinicianDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianControllerUpdateClinician>>, TError,{clinicianId: string;data: UpdateClinicianDto}, TContext> => {

const mutationKey = ['clinicianControllerUpdateClinician'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianControllerUpdateClinician>>, {clinicianId: string;data: UpdateClinicianDto}> = (props) => {
          const {clinicianId,data} = props ?? {};

          return  clinicianControllerUpdateClinician(clinicianId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianControllerUpdateClinicianMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianControllerUpdateClinician>>>
    export type ClinicianControllerUpdateClinicianMutationBody = UpdateClinicianDto
    export type ClinicianControllerUpdateClinicianMutationError = ErrorType<ApiExceptionDto>

    export const useClinicianControllerUpdateClinician = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianControllerUpdateClinician>>, TError,{clinicianId: string;data: UpdateClinicianDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianControllerUpdateClinician>>,
        TError,
        {clinicianId: string;data: UpdateClinicianDto},
        TContext
      > => {

      const mutationOptions = getClinicianControllerUpdateClinicianMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetSessionsList = (
    params?: SessionControllerGetSessionsListParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionListResponseDto>(
      {url: `/v1/clinician-api/session`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSessionControllerGetSessionsListQueryKey = (params?: SessionControllerGetSessionsListParams,) => {
    return [`/v1/clinician-api/session`, ...(params ? [params]: [])] as const;
    }

    
export const getSessionControllerGetSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetSessionsList>>, TError = ErrorType<void>>(params?: SessionControllerGetSessionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionsList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetSessionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetSessionsList>>> = ({ signal }) => sessionControllerGetSessionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetSessionsList>>>
export type SessionControllerGetSessionsListQueryError = ErrorType<void>



export function useSessionControllerGetSessionsList<TData = Awaited<ReturnType<typeof sessionControllerGetSessionsList>>, TError = ErrorType<void>>(
 params?: SessionControllerGetSessionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionsList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerPostSession = (
    sessionCreateBodyDto: SessionCreateBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionDraftDto>(
      {url: `/v1/clinician-api/session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionCreateBodyDto, signal
    },
      );
    }
  


export const getSessionControllerPostSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostSession>>, TError,{data: SessionCreateBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostSession>>, TError,{data: SessionCreateBodyDto}, TContext> => {

const mutationKey = ['sessionControllerPostSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostSession>>, {data: SessionCreateBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerPostSession(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPostSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostSession>>>
    export type SessionControllerPostSessionMutationBody = SessionCreateBodyDto
    export type SessionControllerPostSessionMutationError = ErrorType<void>

    export const useSessionControllerPostSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostSession>>, TError,{data: SessionCreateBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPostSession>>,
        TError,
        {data: SessionCreateBodyDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerPostSessionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetCompletedSessionDetails = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CompletedSessionDto>(
      {url: `/v1/clinician-api/session/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetCompletedSessionDetailsQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}`] as const;
    }

    
export const getSessionControllerGetCompletedSessionDetailsQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetCompletedSessionDetailsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>> = ({ signal }) => sessionControllerGetCompletedSessionDetails(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetCompletedSessionDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>>
export type SessionControllerGetCompletedSessionDetailsQueryError = ErrorType<void>



export function useSessionControllerGetCompletedSessionDetails<TData = Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetCompletedSessionDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerDeleteSession = (
    id: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getSessionControllerDeleteSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerDeleteSession>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerDeleteSession>>, TError,{id: string}, TContext> => {

const mutationKey = ['sessionControllerDeleteSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerDeleteSession>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sessionControllerDeleteSession(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerDeleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerDeleteSession>>>
    
    export type SessionControllerDeleteSessionMutationError = ErrorType<void>

    export const useSessionControllerDeleteSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerDeleteSession>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerDeleteSession>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerDeleteSessionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerPatchSession = (
    id: string,
    sessionPatchDtoV2: SessionPatchDtoV2,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: sessionPatchDtoV2
    },
      );
    }
  


export const getSessionControllerPatchSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchSession>>, TError,{id: string;data: SessionPatchDtoV2}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchSession>>, TError,{id: string;data: SessionPatchDtoV2}, TContext> => {

const mutationKey = ['sessionControllerPatchSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPatchSession>>, {id: string;data: SessionPatchDtoV2}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPatchSession(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPatchSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPatchSession>>>
    export type SessionControllerPatchSessionMutationBody = SessionPatchDtoV2
    export type SessionControllerPatchSessionMutationError = ErrorType<void>

    export const useSessionControllerPatchSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchSession>>, TError,{id: string;data: SessionPatchDtoV2}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPatchSession>>,
        TError,
        {id: string;data: SessionPatchDtoV2},
        TContext
      > => {

      const mutationOptions = getSessionControllerPatchSessionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetCompletedSessionDetailsV2 = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CompletedSessionDtoV2>(
      {url: `/v2/clinician-api/session/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetCompletedSessionDetailsV2QueryKey = (id: string,) => {
    return [`/v2/clinician-api/session/${id}`] as const;
    }

    
export const getSessionControllerGetCompletedSessionDetailsV2QueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetCompletedSessionDetailsV2QueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>> = ({ signal }) => sessionControllerGetCompletedSessionDetailsV2(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetCompletedSessionDetailsV2QueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>>
export type SessionControllerGetCompletedSessionDetailsV2QueryError = ErrorType<void>



export function useSessionControllerGetCompletedSessionDetailsV2<TData = Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetCompletedSessionDetailsV2>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetCompletedSessionDetailsV2QueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerPatchSessionV2 = (
    id: string,
    sessionPatchDtoV2: SessionPatchDtoV2,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v2/clinician-api/session/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: sessionPatchDtoV2
    },
      );
    }
  


export const getSessionControllerPatchSessionV2MutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchSessionV2>>, TError,{id: string;data: SessionPatchDtoV2}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchSessionV2>>, TError,{id: string;data: SessionPatchDtoV2}, TContext> => {

const mutationKey = ['sessionControllerPatchSessionV2'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPatchSessionV2>>, {id: string;data: SessionPatchDtoV2}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPatchSessionV2(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPatchSessionV2MutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPatchSessionV2>>>
    export type SessionControllerPatchSessionV2MutationBody = SessionPatchDtoV2
    export type SessionControllerPatchSessionV2MutationError = ErrorType<void>

    export const useSessionControllerPatchSessionV2 = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchSessionV2>>, TError,{id: string;data: SessionPatchDtoV2}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPatchSessionV2>>,
        TError,
        {id: string;data: SessionPatchDtoV2},
        TContext
      > => {

      const mutationOptions = getSessionControllerPatchSessionV2MutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetProgressNotesForSession = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionProgressNotesDto>(
      {url: `/v1/clinician-api/session/${id}/progress-notes`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetProgressNotesForSessionQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/progress-notes`] as const;
    }

    
export const getSessionControllerGetProgressNotesForSessionQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetProgressNotesForSessionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>> = ({ signal }) => sessionControllerGetProgressNotesForSession(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetProgressNotesForSessionQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>>
export type SessionControllerGetProgressNotesForSessionQueryError = ErrorType<void>



export function useSessionControllerGetProgressNotesForSession<TData = Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetProgressNotesForSessionQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerPatchProgressNote = (
    id: string,
    noteId: string,
    patchNoteDto: PatchNoteDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/progress-notes/${noteId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchNoteDto
    },
      );
    }
  


export const getSessionControllerPatchProgressNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, TError,{id: string;noteId: string;data: PatchNoteDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, TError,{id: string;noteId: string;data: PatchNoteDto}, TContext> => {

const mutationKey = ['sessionControllerPatchProgressNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, {id: string;noteId: string;data: PatchNoteDto}> = (props) => {
          const {id,noteId,data} = props ?? {};

          return  sessionControllerPatchProgressNote(id,noteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPatchProgressNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>>
    export type SessionControllerPatchProgressNoteMutationBody = PatchNoteDto
    export type SessionControllerPatchProgressNoteMutationError = ErrorType<void>

    export const useSessionControllerPatchProgressNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, TError,{id: string;noteId: string;data: PatchNoteDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>,
        TError,
        {id: string;noteId: string;data: PatchNoteDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerPatchProgressNoteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerStartInterventions = (
    id: string,
    startInterventionsBodyDto: StartInterventionsBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/start-interventions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startInterventionsBodyDto, signal
    },
      );
    }
  


export const getSessionControllerStartInterventionsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartInterventions>>, TError,{id: string;data: StartInterventionsBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartInterventions>>, TError,{id: string;data: StartInterventionsBodyDto}, TContext> => {

const mutationKey = ['sessionControllerStartInterventions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerStartInterventions>>, {id: string;data: StartInterventionsBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerStartInterventions(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerStartInterventionsMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerStartInterventions>>>
    export type SessionControllerStartInterventionsMutationBody = StartInterventionsBodyDto
    export type SessionControllerStartInterventionsMutationError = ErrorType<void>

    export const useSessionControllerStartInterventions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartInterventions>>, TError,{id: string;data: StartInterventionsBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerStartInterventions>>,
        TError,
        {id: string;data: StartInterventionsBodyDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerStartInterventionsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetStartedInterventions = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientInterventionWithInterventionDto[]>(
      {url: `/v1/clinician-api/session/${id}/started-interventions`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetStartedInterventionsQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/started-interventions`] as const;
    }

    
export const getSessionControllerGetStartedInterventionsQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetStartedInterventionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>> = ({ signal }) => sessionControllerGetStartedInterventions(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetStartedInterventionsQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>>
export type SessionControllerGetStartedInterventionsQueryError = ErrorType<void>



export function useSessionControllerGetStartedInterventions<TData = Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetStartedInterventions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetStartedInterventionsQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerDeleteIntervention = (
    id: string,
    patientInterventionId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/interventions/${patientInterventionId}`, method: 'DELETE'
    },
      );
    }
  


export const getSessionControllerDeleteInterventionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerDeleteIntervention>>, TError,{id: string;patientInterventionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerDeleteIntervention>>, TError,{id: string;patientInterventionId: string}, TContext> => {

const mutationKey = ['sessionControllerDeleteIntervention'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerDeleteIntervention>>, {id: string;patientInterventionId: string}> = (props) => {
          const {id,patientInterventionId} = props ?? {};

          return  sessionControllerDeleteIntervention(id,patientInterventionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerDeleteInterventionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerDeleteIntervention>>>
    
    export type SessionControllerDeleteInterventionMutationError = ErrorType<void>

    export const useSessionControllerDeleteIntervention = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerDeleteIntervention>>, TError,{id: string;patientInterventionId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerDeleteIntervention>>,
        TError,
        {id: string;patientInterventionId: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerDeleteInterventionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerUpdatePsychotherapyNote = (
    id: string,
    sessionPsychotherapyNoteBodyDto: SessionPsychotherapyNoteBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/psychotherapy-note`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionPsychotherapyNoteBodyDto, signal
    },
      );
    }
  


export const getSessionControllerUpdatePsychotherapyNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUpdatePsychotherapyNote>>, TError,{id: string;data: SessionPsychotherapyNoteBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUpdatePsychotherapyNote>>, TError,{id: string;data: SessionPsychotherapyNoteBodyDto}, TContext> => {

const mutationKey = ['sessionControllerUpdatePsychotherapyNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerUpdatePsychotherapyNote>>, {id: string;data: SessionPsychotherapyNoteBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerUpdatePsychotherapyNote(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerUpdatePsychotherapyNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerUpdatePsychotherapyNote>>>
    export type SessionControllerUpdatePsychotherapyNoteMutationBody = SessionPsychotherapyNoteBodyDto
    export type SessionControllerUpdatePsychotherapyNoteMutationError = ErrorType<void>

    export const useSessionControllerUpdatePsychotherapyNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUpdatePsychotherapyNote>>, TError,{id: string;data: SessionPsychotherapyNoteBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerUpdatePsychotherapyNote>>,
        TError,
        {id: string;data: SessionPsychotherapyNoteBodyDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerUpdatePsychotherapyNoteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetSessionRecap = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionRecapResponse>(
      {url: `/v1/clinician-api/session/${id}/recap`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetSessionRecapQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/recap`] as const;
    }

    
export const getSessionControllerGetSessionRecapQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetSessionRecapQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>> = ({ signal }) => sessionControllerGetSessionRecap(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetSessionRecapQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>>
export type SessionControllerGetSessionRecapQueryError = ErrorType<void>



export function useSessionControllerGetSessionRecap<TData = Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetSessionRecapQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerTrackEvent = (
    id: string,
    trackEventDto: TrackEventDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/track-event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackEventDto, signal
    },
      );
    }
  


export const getSessionControllerTrackEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, TError,{id: string;data: TrackEventDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, TError,{id: string;data: TrackEventDto}, TContext> => {

const mutationKey = ['sessionControllerTrackEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, {id: string;data: TrackEventDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerTrackEvent(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerTrackEventMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerTrackEvent>>>
    export type SessionControllerTrackEventMutationBody = TrackEventDto
    export type SessionControllerTrackEventMutationError = ErrorType<void>

    export const useSessionControllerTrackEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, TError,{id: string;data: TrackEventDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerTrackEvent>>,
        TError,
        {id: string;data: TrackEventDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerTrackEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerPostPlannedInterventions = (
    id: string,
    sessionPlannedInterventionsBodyDto: SessionPlannedInterventionsBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/planned-interventions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionPlannedInterventionsBodyDto, signal
    },
      );
    }
  


export const getSessionControllerPostPlannedInterventionsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, TError,{id: string;data: SessionPlannedInterventionsBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, TError,{id: string;data: SessionPlannedInterventionsBodyDto}, TContext> => {

const mutationKey = ['sessionControllerPostPlannedInterventions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, {id: string;data: SessionPlannedInterventionsBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPostPlannedInterventions(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPostPlannedInterventionsMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>>
    export type SessionControllerPostPlannedInterventionsMutationBody = SessionPlannedInterventionsBodyDto
    export type SessionControllerPostPlannedInterventionsMutationError = ErrorType<void>

    export const useSessionControllerPostPlannedInterventions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, TError,{id: string;data: SessionPlannedInterventionsBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>,
        TError,
        {id: string;data: SessionPlannedInterventionsBodyDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerPostPlannedInterventionsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerCreateSampleSession = (
    createSampleSessionDto: CreateSampleSessionDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SampleSessionDto>(
      {url: `/v1/clinician-api/session/sample`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSampleSessionDto, signal
    },
      );
    }
  


export const getSessionControllerCreateSampleSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, TError,{data: CreateSampleSessionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, TError,{data: CreateSampleSessionDto}, TContext> => {

const mutationKey = ['sessionControllerCreateSampleSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, {data: CreateSampleSessionDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCreateSampleSession(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerCreateSampleSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>>
    export type SessionControllerCreateSampleSessionMutationBody = CreateSampleSessionDto
    export type SessionControllerCreateSampleSessionMutationError = ErrorType<void>

    export const useSessionControllerCreateSampleSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, TError,{data: CreateSampleSessionDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>,
        TError,
        {data: CreateSampleSessionDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerCreateSampleSessionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerStartUpload = (
    startUploadDto: StartUploadDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/start-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startUploadDto, signal
    },
      );
    }
  


export const getSessionControllerStartUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartUpload>>, TError,{data: StartUploadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartUpload>>, TError,{data: StartUploadDto}, TContext> => {

const mutationKey = ['sessionControllerStartUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerStartUpload>>, {data: StartUploadDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerStartUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerStartUploadMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerStartUpload>>>
    export type SessionControllerStartUploadMutationBody = StartUploadDto
    export type SessionControllerStartUploadMutationError = ErrorType<void>

    export const useSessionControllerStartUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartUpload>>, TError,{data: StartUploadDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerStartUpload>>,
        TError,
        {data: StartUploadDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerStartUploadMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerCompleteUpload = (
    completeUploadDto: CompleteUploadDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/complete-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeUploadDto, signal
    },
      );
    }
  


export const getSessionControllerCompleteUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, TError,{data: CompleteUploadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, TError,{data: CompleteUploadDto}, TContext> => {

const mutationKey = ['sessionControllerCompleteUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, {data: CompleteUploadDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCompleteUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerCompleteUploadMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>>
    export type SessionControllerCompleteUploadMutationBody = CompleteUploadDto
    export type SessionControllerCompleteUploadMutationError = ErrorType<void>

    export const useSessionControllerCompleteUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, TError,{data: CompleteUploadDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerCompleteUpload>>,
        TError,
        {data: CompleteUploadDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerCompleteUploadMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerPostDiscardSession = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/discard-session`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerPostDiscardSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, TError,{id: string}, TContext> => {

const mutationKey = ['sessionControllerPostDiscardSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sessionControllerPostDiscardSession(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPostDiscardSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>>
    
    export type SessionControllerPostDiscardSessionMutationError = ErrorType<void>

    export const useSessionControllerPostDiscardSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerPostDiscardSessionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerPostMarkComplete = (
    id: string,
    markSessionCompleteBodyDto: MarkSessionCompleteBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/mark-complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markSessionCompleteBodyDto, signal
    },
      );
    }
  


export const getSessionControllerPostMarkCompleteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostMarkComplete>>, TError,{id: string;data: MarkSessionCompleteBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostMarkComplete>>, TError,{id: string;data: MarkSessionCompleteBodyDto}, TContext> => {

const mutationKey = ['sessionControllerPostMarkComplete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostMarkComplete>>, {id: string;data: MarkSessionCompleteBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPostMarkComplete(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPostMarkCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostMarkComplete>>>
    export type SessionControllerPostMarkCompleteMutationBody = MarkSessionCompleteBodyDto
    export type SessionControllerPostMarkCompleteMutationError = ErrorType<void>

    export const useSessionControllerPostMarkComplete = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostMarkComplete>>, TError,{id: string;data: MarkSessionCompleteBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPostMarkComplete>>,
        TError,
        {id: string;data: MarkSessionCompleteBodyDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerPostMarkCompleteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerPostMarkCompleteV2 = (
    id: string,
    markSessionCompleteBodyDtoV2: MarkSessionCompleteBodyDtoV2,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v2/clinician-api/session/${id}/mark-complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markSessionCompleteBodyDtoV2, signal
    },
      );
    }
  


export const getSessionControllerPostMarkCompleteV2MutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostMarkCompleteV2>>, TError,{id: string;data: MarkSessionCompleteBodyDtoV2}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostMarkCompleteV2>>, TError,{id: string;data: MarkSessionCompleteBodyDtoV2}, TContext> => {

const mutationKey = ['sessionControllerPostMarkCompleteV2'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostMarkCompleteV2>>, {id: string;data: MarkSessionCompleteBodyDtoV2}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPostMarkCompleteV2(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPostMarkCompleteV2MutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostMarkCompleteV2>>>
    export type SessionControllerPostMarkCompleteV2MutationBody = MarkSessionCompleteBodyDtoV2
    export type SessionControllerPostMarkCompleteV2MutationError = ErrorType<void>

    export const useSessionControllerPostMarkCompleteV2 = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostMarkCompleteV2>>, TError,{id: string;data: MarkSessionCompleteBodyDtoV2}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPostMarkCompleteV2>>,
        TError,
        {id: string;data: MarkSessionCompleteBodyDtoV2},
        TContext
      > => {

      const mutationOptions = getSessionControllerPostMarkCompleteV2MutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerCreateFromUploadedAudio = (
    sessionFromUploadedAudioBodyDto: SessionFromUploadedAudioBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CompletedSessionDto>(
      {url: `/v1/clinician-api/session/from-uploaded-audio`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionFromUploadedAudioBodyDto, signal
    },
      );
    }
  


export const getSessionControllerCreateFromUploadedAudioMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudio>>, TError,{data: SessionFromUploadedAudioBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudio>>, TError,{data: SessionFromUploadedAudioBodyDto}, TContext> => {

const mutationKey = ['sessionControllerCreateFromUploadedAudio'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudio>>, {data: SessionFromUploadedAudioBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCreateFromUploadedAudio(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerCreateFromUploadedAudioMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudio>>>
    export type SessionControllerCreateFromUploadedAudioMutationBody = SessionFromUploadedAudioBodyDto
    export type SessionControllerCreateFromUploadedAudioMutationError = ErrorType<void>

    export const useSessionControllerCreateFromUploadedAudio = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudio>>, TError,{data: SessionFromUploadedAudioBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudio>>,
        TError,
        {data: SessionFromUploadedAudioBodyDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerCreateFromUploadedAudioMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerCreateFromUploadedAudioV2 = (
    sessionFromUploadedAudioBodyDtoV2: SessionFromUploadedAudioBodyDtoV2,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CompletedSessionDtoV2>(
      {url: `/v2/clinician-api/session/from-uploaded-audio`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionFromUploadedAudioBodyDtoV2, signal
    },
      );
    }
  


export const getSessionControllerCreateFromUploadedAudioV2MutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudioV2>>, TError,{data: SessionFromUploadedAudioBodyDtoV2}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudioV2>>, TError,{data: SessionFromUploadedAudioBodyDtoV2}, TContext> => {

const mutationKey = ['sessionControllerCreateFromUploadedAudioV2'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudioV2>>, {data: SessionFromUploadedAudioBodyDtoV2}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCreateFromUploadedAudioV2(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerCreateFromUploadedAudioV2MutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudioV2>>>
    export type SessionControllerCreateFromUploadedAudioV2MutationBody = SessionFromUploadedAudioBodyDtoV2
    export type SessionControllerCreateFromUploadedAudioV2MutationError = ErrorType<void>

    export const useSessionControllerCreateFromUploadedAudioV2 = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudioV2>>, TError,{data: SessionFromUploadedAudioBodyDtoV2}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerCreateFromUploadedAudioV2>>,
        TError,
        {data: SessionFromUploadedAudioBodyDtoV2},
        TContext
      > => {

      const mutationOptions = getSessionControllerCreateFromUploadedAudioV2MutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerPostContentSuggestions = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/generate-suggestions`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerPostContentSuggestionsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostContentSuggestions>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostContentSuggestions>>, TError,{id: string}, TContext> => {

const mutationKey = ['sessionControllerPostContentSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostContentSuggestions>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sessionControllerPostContentSuggestions(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerPostContentSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostContentSuggestions>>>
    
    export type SessionControllerPostContentSuggestionsMutationError = ErrorType<void>

    export const useSessionControllerPostContentSuggestions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostContentSuggestions>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerPostContentSuggestions>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerPostContentSuggestionsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetContentExclusionReasons = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/content-exclusion-reasons`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetContentExclusionReasonsQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/content-exclusion-reasons`] as const;
    }

    
export const getSessionControllerGetContentExclusionReasonsQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetContentExclusionReasonsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>> = ({ signal }) => sessionControllerGetContentExclusionReasons(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetContentExclusionReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>>
export type SessionControllerGetContentExclusionReasonsQueryError = ErrorType<void>



export function useSessionControllerGetContentExclusionReasons<TData = Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetContentExclusionReasons>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetContentExclusionReasonsQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerGetSuggestedContent = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SuggestedContentDTO>(
      {url: `/v1/clinician-api/session/${id}/content-suggestions`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetSuggestedContentQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/content-suggestions`] as const;
    }

    
export const getSessionControllerGetSuggestedContentQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetSuggestedContentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>> = ({ signal }) => sessionControllerGetSuggestedContent(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetSuggestedContentQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>>
export type SessionControllerGetSuggestedContentQueryError = ErrorType<void>



export function useSessionControllerGetSuggestedContent<TData = Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSuggestedContent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetSuggestedContentQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerGetDemoSuggestedContent = (
    id: string,
    params: SessionControllerGetDemoSuggestedContentParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SuggestedContentDTO>(
      {url: `/v1/clinician-api/session/${id}/demo-content-suggestions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSessionControllerGetDemoSuggestedContentQueryKey = (id: string,
    params: SessionControllerGetDemoSuggestedContentParams,) => {
    return [`/v1/clinician-api/session/${id}/demo-content-suggestions`, ...(params ? [params]: [])] as const;
    }

    
export const getSessionControllerGetDemoSuggestedContentQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>, TError = ErrorType<void>>(id: string,
    params: SessionControllerGetDemoSuggestedContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetDemoSuggestedContentQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>> = ({ signal }) => sessionControllerGetDemoSuggestedContent(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetDemoSuggestedContentQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>>
export type SessionControllerGetDemoSuggestedContentQueryError = ErrorType<void>



export function useSessionControllerGetDemoSuggestedContent<TData = Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>, TError = ErrorType<void>>(
 id: string,
    params: SessionControllerGetDemoSuggestedContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetDemoSuggestedContent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetDemoSuggestedContentQueryOptions(id,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerGetSessionPrep = (
    id: string,
    params?: SessionControllerGetSessionPrepParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionPrepDto>(
      {url: `/v1/clinician-api/session/${id}/prep`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSessionControllerGetSessionPrepQueryKey = (id: string,
    params?: SessionControllerGetSessionPrepParams,) => {
    return [`/v1/clinician-api/session/${id}/prep`, ...(params ? [params]: [])] as const;
    }

    
export const getSessionControllerGetSessionPrepQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>, TError = ErrorType<void>>(id: string,
    params?: SessionControllerGetSessionPrepParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetSessionPrepQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>> = ({ signal }) => sessionControllerGetSessionPrep(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetSessionPrepQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>>
export type SessionControllerGetSessionPrepQueryError = ErrorType<void>



export function useSessionControllerGetSessionPrep<TData = Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>, TError = ErrorType<void>>(
 id: string,
    params?: SessionControllerGetSessionPrepParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionPrep>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetSessionPrepQueryOptions(id,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerInitiateSessionPrepGeneration = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/initiate-prep-generation`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerInitiateSessionPrepGenerationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerInitiateSessionPrepGeneration>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerInitiateSessionPrepGeneration>>, TError,{id: string}, TContext> => {

const mutationKey = ['sessionControllerInitiateSessionPrepGeneration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerInitiateSessionPrepGeneration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sessionControllerInitiateSessionPrepGeneration(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerInitiateSessionPrepGenerationMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerInitiateSessionPrepGeneration>>>
    
    export type SessionControllerInitiateSessionPrepGenerationMutationError = ErrorType<void>

    export const useSessionControllerInitiateSessionPrepGeneration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerInitiateSessionPrepGeneration>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerInitiateSessionPrepGeneration>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerInitiateSessionPrepGenerationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerUploadNoteToEhr = (
    id: string,
    noteId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/progress-notes/${noteId}/upload-to-ehr`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerUploadNoteToEhrMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUploadNoteToEhr>>, TError,{id: string;noteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUploadNoteToEhr>>, TError,{id: string;noteId: string}, TContext> => {

const mutationKey = ['sessionControllerUploadNoteToEhr'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerUploadNoteToEhr>>, {id: string;noteId: string}> = (props) => {
          const {id,noteId} = props ?? {};

          return  sessionControllerUploadNoteToEhr(id,noteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerUploadNoteToEhrMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerUploadNoteToEhr>>>
    
    export type SessionControllerUploadNoteToEhrMutationError = ErrorType<void>

    export const useSessionControllerUploadNoteToEhr = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUploadNoteToEhr>>, TError,{id: string;noteId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerUploadNoteToEhr>>,
        TError,
        {id: string;noteId: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerUploadNoteToEhrMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerFinalizeNote = (
    id: string,
    noteId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/progress-notes/${noteId}/finalize`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerFinalizeNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerFinalizeNote>>, TError,{id: string;noteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerFinalizeNote>>, TError,{id: string;noteId: string}, TContext> => {

const mutationKey = ['sessionControllerFinalizeNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerFinalizeNote>>, {id: string;noteId: string}> = (props) => {
          const {id,noteId} = props ?? {};

          return  sessionControllerFinalizeNote(id,noteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerFinalizeNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerFinalizeNote>>>
    
    export type SessionControllerFinalizeNoteMutationError = ErrorType<void>

    export const useSessionControllerFinalizeNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerFinalizeNote>>, TError,{id: string;noteId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerFinalizeNote>>,
        TError,
        {id: string;noteId: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerFinalizeNoteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerLockNote = (
    id: string,
    noteId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/progress-notes/${noteId}/lock`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerLockNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerLockNote>>, TError,{id: string;noteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerLockNote>>, TError,{id: string;noteId: string}, TContext> => {

const mutationKey = ['sessionControllerLockNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerLockNote>>, {id: string;noteId: string}> = (props) => {
          const {id,noteId} = props ?? {};

          return  sessionControllerLockNote(id,noteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerLockNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerLockNote>>>
    
    export type SessionControllerLockNoteMutationError = ErrorType<void>

    export const useSessionControllerLockNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerLockNote>>, TError,{id: string;noteId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerLockNote>>,
        TError,
        {id: string;noteId: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerLockNoteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerSelectVersion = (
    id: string,
    noteId: string,
    selectVersionDto: SelectVersionDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/${id}/progress-notes/${noteId}/select-version`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selectVersionDto, signal
    },
      );
    }
  


export const getSessionControllerSelectVersionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerSelectVersion>>, TError,{id: string;noteId: string;data: SelectVersionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerSelectVersion>>, TError,{id: string;noteId: string;data: SelectVersionDto}, TContext> => {

const mutationKey = ['sessionControllerSelectVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerSelectVersion>>, {id: string;noteId: string;data: SelectVersionDto}> = (props) => {
          const {id,noteId,data} = props ?? {};

          return  sessionControllerSelectVersion(id,noteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerSelectVersionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerSelectVersion>>>
    export type SessionControllerSelectVersionMutationBody = SelectVersionDto
    export type SessionControllerSelectVersionMutationError = ErrorType<void>

    export const useSessionControllerSelectVersion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerSelectVersion>>, TError,{id: string;noteId: string;data: SelectVersionDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerSelectVersion>>,
        TError,
        {id: string;noteId: string;data: SelectVersionDto},
        TContext
      > => {

      const mutationOptions = getSessionControllerSelectVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerUnlockNote = (
    id: string,
    noteId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionProgressNoteDto>(
      {url: `/v1/clinician-api/session/${id}/progress-notes/${noteId}/unlock`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerUnlockNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUnlockNote>>, TError,{id: string;noteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUnlockNote>>, TError,{id: string;noteId: string}, TContext> => {

const mutationKey = ['sessionControllerUnlockNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerUnlockNote>>, {id: string;noteId: string}> = (props) => {
          const {id,noteId} = props ?? {};

          return  sessionControllerUnlockNote(id,noteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerUnlockNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerUnlockNote>>>
    
    export type SessionControllerUnlockNoteMutationError = ErrorType<void>

    export const useSessionControllerUnlockNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUnlockNote>>, TError,{id: string;noteId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerUnlockNote>>,
        TError,
        {id: string;noteId: string},
        TContext
      > => {

      const mutationOptions = getSessionControllerUnlockNoteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerGetTelehealthMeetingToken = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<TelehealthMeetingTokenDto>(
      {url: `/v1/clinician-api/session/${id}/teleheath/meeting-token`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerGetTelehealthMeetingTokenQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/teleheath/meeting-token`] as const;
    }

    
export const getSessionControllerGetTelehealthMeetingTokenQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerGetTelehealthMeetingTokenQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>> = ({ signal }) => sessionControllerGetTelehealthMeetingToken(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerGetTelehealthMeetingTokenQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>>
export type SessionControllerGetTelehealthMeetingTokenQueryError = ErrorType<void>



export function useSessionControllerGetTelehealthMeetingToken<TData = Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetTelehealthMeetingToken>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerGetTelehealthMeetingTokenQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sessionControllerUpgradeNowEmail = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/session/upgrade-now-email`, method: 'POST', signal
    },
      );
    }
  


export const getSessionControllerUpgradeNowEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUpgradeNowEmail>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUpgradeNowEmail>>, TError,void, TContext> => {

const mutationKey = ['sessionControllerUpgradeNowEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerUpgradeNowEmail>>, void> = () => {
          

          return  sessionControllerUpgradeNowEmail()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SessionControllerUpgradeNowEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerUpgradeNowEmail>>>
    
    export type SessionControllerUpgradeNowEmailMutationError = ErrorType<void>

    export const useSessionControllerUpgradeNowEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerUpgradeNowEmail>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sessionControllerUpgradeNowEmail>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSessionControllerUpgradeNowEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sessionControllerDebug = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionDebugDto>(
      {url: `/v1/clinician-api/session/${id}/debug`, method: 'GET', signal
    },
      );
    }
  

export const getSessionControllerDebugQueryKey = (id: string,) => {
    return [`/v1/clinician-api/session/${id}/debug`] as const;
    }

    
export const getSessionControllerDebugQueryOptions = <TData = Awaited<ReturnType<typeof sessionControllerDebug>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerDebug>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSessionControllerDebugQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerDebug>>> = ({ signal }) => sessionControllerDebug(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sessionControllerDebug>>, TError, TData> & { queryKey: QueryKey }
}

export type SessionControllerDebugQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerDebug>>>
export type SessionControllerDebugQueryError = ErrorType<void>



export function useSessionControllerDebug<TData = Awaited<ReturnType<typeof sessionControllerDebug>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerDebug>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSessionControllerDebugQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerGetPatients = (
    params: PatientControllerGetPatientsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientDto[]>(
      {url: `/v1/clinician-api/patient/patients`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPatientControllerGetPatientsQueryKey = (params: PatientControllerGetPatientsParams,) => {
    return [`/v1/clinician-api/patient/patients`, ...(params ? [params]: [])] as const;
    }

    
export const getPatientControllerGetPatientsQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetPatients>>, TError = ErrorType<void>>(params: PatientControllerGetPatientsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetPatients>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetPatientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetPatients>>> = ({ signal }) => patientControllerGetPatients(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetPatients>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetPatients>>>
export type PatientControllerGetPatientsQueryError = ErrorType<void>



export function usePatientControllerGetPatients<TData = Awaited<ReturnType<typeof patientControllerGetPatients>>, TError = ErrorType<void>>(
 params: PatientControllerGetPatientsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetPatients>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetPatientsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerAssistEnroll = (
    patientId: string,
    assistEnrollDto: AssistEnrollDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/assist-enroll`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assistEnrollDto, signal
    },
      );
    }
  


export const getPatientControllerAssistEnrollMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerAssistEnroll>>, TError,{patientId: string;data: AssistEnrollDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerAssistEnroll>>, TError,{patientId: string;data: AssistEnrollDto}, TContext> => {

const mutationKey = ['patientControllerAssistEnroll'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerAssistEnroll>>, {patientId: string;data: AssistEnrollDto}> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientControllerAssistEnroll(patientId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerAssistEnrollMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerAssistEnroll>>>
    export type PatientControllerAssistEnrollMutationBody = AssistEnrollDto
    export type PatientControllerAssistEnrollMutationError = ErrorType<void>

    export const usePatientControllerAssistEnroll = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerAssistEnroll>>, TError,{patientId: string;data: AssistEnrollDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerAssistEnroll>>,
        TError,
        {patientId: string;data: AssistEnrollDto},
        TContext
      > => {

      const mutationOptions = getPatientControllerAssistEnrollMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerDeleteClient = (
    patientId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}`, method: 'DELETE'
    },
      );
    }
  


export const getPatientControllerDeleteClientMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerDeleteClient>>, TError,{patientId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerDeleteClient>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['patientControllerDeleteClient'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerDeleteClient>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  patientControllerDeleteClient(patientId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerDeleteClientMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerDeleteClient>>>
    
    export type PatientControllerDeleteClientMutationError = ErrorType<void>

    export const usePatientControllerDeleteClient = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerDeleteClient>>, TError,{patientId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerDeleteClient>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getPatientControllerDeleteClientMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerGetSessionList = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionDto[]>(
      {url: `/v1/clinician-api/patient/${patientId}/session-list`, method: 'GET', signal
    },
      );
    }
  

export const getPatientControllerGetSessionListQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/session-list`] as const;
    }

    
export const getPatientControllerGetSessionListQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetSessionList>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetSessionList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetSessionListQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetSessionList>>> = ({ signal }) => patientControllerGetSessionList(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetSessionList>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetSessionListQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetSessionList>>>
export type PatientControllerGetSessionListQueryError = ErrorType<void>



export function usePatientControllerGetSessionList<TData = Awaited<ReturnType<typeof patientControllerGetSessionList>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetSessionList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetSessionListQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerGetCheckInScores = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientCheckInScoresDto>(
      {url: `/v1/clinician-api/patient/${patientId}/check-ins/scores`, method: 'GET', signal
    },
      );
    }
  

export const getPatientControllerGetCheckInScoresQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/check-ins/scores`] as const;
    }

    
export const getPatientControllerGetCheckInScoresQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetCheckInScores>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetCheckInScores>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetCheckInScoresQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetCheckInScores>>> = ({ signal }) => patientControllerGetCheckInScores(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetCheckInScores>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetCheckInScoresQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetCheckInScores>>>
export type PatientControllerGetCheckInScoresQueryError = ErrorType<void>



export function usePatientControllerGetCheckInScores<TData = Awaited<ReturnType<typeof patientControllerGetCheckInScores>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetCheckInScores>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetCheckInScoresQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerGetConsent = (
    patientId: string,
    params: PatientControllerGetConsentParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientConsentDto>(
      {url: `/v1/clinician-api/patient/${patientId}/consent`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPatientControllerGetConsentQueryKey = (patientId: string,
    params: PatientControllerGetConsentParams,) => {
    return [`/v1/clinician-api/patient/${patientId}/consent`, ...(params ? [params]: [])] as const;
    }

    
export const getPatientControllerGetConsentQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetConsent>>, TError = ErrorType<void>>(patientId: string,
    params: PatientControllerGetConsentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetConsent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetConsentQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetConsent>>> = ({ signal }) => patientControllerGetConsent(patientId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetConsent>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetConsentQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetConsent>>>
export type PatientControllerGetConsentQueryError = ErrorType<void>



export function usePatientControllerGetConsent<TData = Awaited<ReturnType<typeof patientControllerGetConsent>>, TError = ErrorType<void>>(
 patientId: string,
    params: PatientControllerGetConsentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetConsent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetConsentQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerAssignCheckIns = (
    patientId: string,
    assignCheckInDto: AssignCheckInDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/checkin/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignCheckInDto, signal
    },
      );
    }
  


export const getPatientControllerAssignCheckInsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerAssignCheckIns>>, TError,{patientId: string;data: AssignCheckInDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerAssignCheckIns>>, TError,{patientId: string;data: AssignCheckInDto}, TContext> => {

const mutationKey = ['patientControllerAssignCheckIns'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerAssignCheckIns>>, {patientId: string;data: AssignCheckInDto}> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientControllerAssignCheckIns(patientId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerAssignCheckInsMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerAssignCheckIns>>>
    export type PatientControllerAssignCheckInsMutationBody = AssignCheckInDto
    export type PatientControllerAssignCheckInsMutationError = ErrorType<void>

    export const usePatientControllerAssignCheckIns = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerAssignCheckIns>>, TError,{patientId: string;data: AssignCheckInDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerAssignCheckIns>>,
        TError,
        {patientId: string;data: AssignCheckInDto},
        TContext
      > => {

      const mutationOptions = getPatientControllerAssignCheckInsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerUnassignCheckIn = (
    patientId: string,
    checkInId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/checkin/${checkInId}/unassign`, method: 'POST', signal
    },
      );
    }
  


export const getPatientControllerUnassignCheckInMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerUnassignCheckIn>>, TError,{patientId: string;checkInId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerUnassignCheckIn>>, TError,{patientId: string;checkInId: string}, TContext> => {

const mutationKey = ['patientControllerUnassignCheckIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerUnassignCheckIn>>, {patientId: string;checkInId: string}> = (props) => {
          const {patientId,checkInId} = props ?? {};

          return  patientControllerUnassignCheckIn(patientId,checkInId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerUnassignCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerUnassignCheckIn>>>
    
    export type PatientControllerUnassignCheckInMutationError = ErrorType<void>

    export const usePatientControllerUnassignCheckIn = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerUnassignCheckIn>>, TError,{patientId: string;checkInId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerUnassignCheckIn>>,
        TError,
        {patientId: string;checkInId: string},
        TContext
      > => {

      const mutationOptions = getPatientControllerUnassignCheckInMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerUpdateCheckInNotification = (
    patientId: string,
    checkInId: string,
    updateCheckInNotificationDto: UpdateCheckInNotificationDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/checkin/${checkInId}/update-notification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateCheckInNotificationDto, signal
    },
      );
    }
  


export const getPatientControllerUpdateCheckInNotificationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerUpdateCheckInNotification>>, TError,{patientId: string;checkInId: string;data: UpdateCheckInNotificationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerUpdateCheckInNotification>>, TError,{patientId: string;checkInId: string;data: UpdateCheckInNotificationDto}, TContext> => {

const mutationKey = ['patientControllerUpdateCheckInNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerUpdateCheckInNotification>>, {patientId: string;checkInId: string;data: UpdateCheckInNotificationDto}> = (props) => {
          const {patientId,checkInId,data} = props ?? {};

          return  patientControllerUpdateCheckInNotification(patientId,checkInId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerUpdateCheckInNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerUpdateCheckInNotification>>>
    export type PatientControllerUpdateCheckInNotificationMutationBody = UpdateCheckInNotificationDto
    export type PatientControllerUpdateCheckInNotificationMutationError = ErrorType<void>

    export const usePatientControllerUpdateCheckInNotification = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerUpdateCheckInNotification>>, TError,{patientId: string;checkInId: string;data: UpdateCheckInNotificationDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerUpdateCheckInNotification>>,
        TError,
        {patientId: string;checkInId: string;data: UpdateCheckInNotificationDto},
        TContext
      > => {

      const mutationOptions = getPatientControllerUpdateCheckInNotificationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerGetAssignedCheckIns = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<AssignedCheckInDto[]>(
      {url: `/v1/clinician-api/patient/${patientId}/assigned-checkins`, method: 'GET', signal
    },
      );
    }
  

export const getPatientControllerGetAssignedCheckInsQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/assigned-checkins`] as const;
    }

    
export const getPatientControllerGetAssignedCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetAssignedCheckInsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>> = ({ signal }) => patientControllerGetAssignedCheckIns(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetAssignedCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>>
export type PatientControllerGetAssignedCheckInsQueryError = ErrorType<void>



export function usePatientControllerGetAssignedCheckIns<TData = Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetAssignedCheckIns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetAssignedCheckInsQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerCreateTelehealthUrl = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClientTelehealthUrlDto>(
      {url: `/v1/clinician-api/patient/${patientId}/telehealth-url`, method: 'POST', signal
    },
      );
    }
  


export const getPatientControllerCreateTelehealthUrlMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerCreateTelehealthUrl>>, TError,{patientId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerCreateTelehealthUrl>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['patientControllerCreateTelehealthUrl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerCreateTelehealthUrl>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  patientControllerCreateTelehealthUrl(patientId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerCreateTelehealthUrlMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerCreateTelehealthUrl>>>
    
    export type PatientControllerCreateTelehealthUrlMutationError = ErrorType<void>

    export const usePatientControllerCreateTelehealthUrl = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerCreateTelehealthUrl>>, TError,{patientId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerCreateTelehealthUrl>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getPatientControllerCreateTelehealthUrlMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerSendIntakeDocuments = (
    patientId: string,
    sendIntakeDocumentsRequestDto: SendIntakeDocumentsRequestDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SendIntakeDocumentsResponseDto>(
      {url: `/v1/clinician-api/patient/${patientId}/send-intake-documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendIntakeDocumentsRequestDto, signal
    },
      );
    }
  


export const getPatientControllerSendIntakeDocumentsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerSendIntakeDocuments>>, TError,{patientId: string;data: SendIntakeDocumentsRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientControllerSendIntakeDocuments>>, TError,{patientId: string;data: SendIntakeDocumentsRequestDto}, TContext> => {

const mutationKey = ['patientControllerSendIntakeDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientControllerSendIntakeDocuments>>, {patientId: string;data: SendIntakeDocumentsRequestDto}> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientControllerSendIntakeDocuments(patientId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientControllerSendIntakeDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof patientControllerSendIntakeDocuments>>>
    export type PatientControllerSendIntakeDocumentsMutationBody = SendIntakeDocumentsRequestDto
    export type PatientControllerSendIntakeDocumentsMutationError = ErrorType<void>

    export const usePatientControllerSendIntakeDocuments = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientControllerSendIntakeDocuments>>, TError,{patientId: string;data: SendIntakeDocumentsRequestDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientControllerSendIntakeDocuments>>,
        TError,
        {patientId: string;data: SendIntakeDocumentsRequestDto},
        TContext
      > => {

      const mutationOptions = getPatientControllerSendIntakeDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientControllerGetIntakeStatus = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientIntakeStatusDto>(
      {url: `/v1/clinician-api/patient/${patientId}/intake/status`, method: 'GET', signal
    },
      );
    }
  

export const getPatientControllerGetIntakeStatusQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/intake/status`] as const;
    }

    
export const getPatientControllerGetIntakeStatusQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetIntakeStatusQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>> = ({ signal }) => patientControllerGetIntakeStatus(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetIntakeStatusQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>>
export type PatientControllerGetIntakeStatusQueryError = ErrorType<void>



export function usePatientControllerGetIntakeStatus<TData = Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetIntakeStatusQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerGetIntakeConsentResults = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientIntakeConsentResultsDto>(
      {url: `/v1/clinician-api/patient/${patientId}/intake/consent-results`, method: 'GET', signal
    },
      );
    }
  

export const getPatientControllerGetIntakeConsentResultsQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/intake/consent-results`] as const;
    }

    
export const getPatientControllerGetIntakeConsentResultsQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetIntakeConsentResultsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>> = ({ signal }) => patientControllerGetIntakeConsentResults(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetIntakeConsentResultsQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>>
export type PatientControllerGetIntakeConsentResultsQueryError = ErrorType<void>



export function usePatientControllerGetIntakeConsentResults<TData = Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeConsentResults>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetIntakeConsentResultsQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientControllerGetIntakeQuestionnaireResults = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientIntakeQuestionnaireResultsDto>(
      {url: `/v1/clinician-api/patient/${patientId}/intake/questionnaire-results`, method: 'GET', signal
    },
      );
    }
  

export const getPatientControllerGetIntakeQuestionnaireResultsQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/intake/questionnaire-results`] as const;
    }

    
export const getPatientControllerGetIntakeQuestionnaireResultsQueryOptions = <TData = Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientControllerGetIntakeQuestionnaireResultsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>> = ({ signal }) => patientControllerGetIntakeQuestionnaireResults(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientControllerGetIntakeQuestionnaireResultsQueryResult = NonNullable<Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>>
export type PatientControllerGetIntakeQuestionnaireResultsQueryError = ErrorType<void>



export function usePatientControllerGetIntakeQuestionnaireResults<TData = Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientControllerGetIntakeQuestionnaireResults>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientControllerGetIntakeQuestionnaireResultsQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const interventionsControllerSaveInterventionForLater = (
    patientId: string,
    interventionId: string,
    saveForLaterBodyDto: SaveForLaterBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/interventions/${interventionId}/save-for-later`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveForLaterBodyDto, signal
    },
      );
    }
  


export const getInterventionsControllerSaveInterventionForLaterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof interventionsControllerSaveInterventionForLater>>, TError,{patientId: string;interventionId: string;data: SaveForLaterBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof interventionsControllerSaveInterventionForLater>>, TError,{patientId: string;interventionId: string;data: SaveForLaterBodyDto}, TContext> => {

const mutationKey = ['interventionsControllerSaveInterventionForLater'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof interventionsControllerSaveInterventionForLater>>, {patientId: string;interventionId: string;data: SaveForLaterBodyDto}> = (props) => {
          const {patientId,interventionId,data} = props ?? {};

          return  interventionsControllerSaveInterventionForLater(patientId,interventionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InterventionsControllerSaveInterventionForLaterMutationResult = NonNullable<Awaited<ReturnType<typeof interventionsControllerSaveInterventionForLater>>>
    export type InterventionsControllerSaveInterventionForLaterMutationBody = SaveForLaterBodyDto
    export type InterventionsControllerSaveInterventionForLaterMutationError = ErrorType<void>

    export const useInterventionsControllerSaveInterventionForLater = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof interventionsControllerSaveInterventionForLater>>, TError,{patientId: string;interventionId: string;data: SaveForLaterBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof interventionsControllerSaveInterventionForLater>>,
        TError,
        {patientId: string;interventionId: string;data: SaveForLaterBodyDto},
        TContext
      > => {

      const mutationOptions = getInterventionsControllerSaveInterventionForLaterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const interventionsControllerGetSavedForLaterInterventions = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SavedForLaterInterventionDto[]>(
      {url: `/v1/clinician-api/patient/${patientId}/interventions/saved-for-later`, method: 'GET', signal
    },
      );
    }
  

export const getInterventionsControllerGetSavedForLaterInterventionsQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/interventions/saved-for-later`] as const;
    }

    
export const getInterventionsControllerGetSavedForLaterInterventionsQueryOptions = <TData = Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInterventionsControllerGetSavedForLaterInterventionsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>> = ({ signal }) => interventionsControllerGetSavedForLaterInterventions(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>, TError, TData> & { queryKey: QueryKey }
}

export type InterventionsControllerGetSavedForLaterInterventionsQueryResult = NonNullable<Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>>
export type InterventionsControllerGetSavedForLaterInterventionsQueryError = ErrorType<void>



export function useInterventionsControllerGetSavedForLaterInterventions<TData = Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerGetSavedForLaterInterventions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInterventionsControllerGetSavedForLaterInterventionsQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const interventionsControllerRemoveInterventionFromSavedForLater = (
    patientId: string,
    interventionId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/interventions/${interventionId}/remove-from-saved`, method: 'DELETE'
    },
      );
    }
  


export const getInterventionsControllerRemoveInterventionFromSavedForLaterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof interventionsControllerRemoveInterventionFromSavedForLater>>, TError,{patientId: string;interventionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof interventionsControllerRemoveInterventionFromSavedForLater>>, TError,{patientId: string;interventionId: string}, TContext> => {

const mutationKey = ['interventionsControllerRemoveInterventionFromSavedForLater'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof interventionsControllerRemoveInterventionFromSavedForLater>>, {patientId: string;interventionId: string}> = (props) => {
          const {patientId,interventionId} = props ?? {};

          return  interventionsControllerRemoveInterventionFromSavedForLater(patientId,interventionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InterventionsControllerRemoveInterventionFromSavedForLaterMutationResult = NonNullable<Awaited<ReturnType<typeof interventionsControllerRemoveInterventionFromSavedForLater>>>
    
    export type InterventionsControllerRemoveInterventionFromSavedForLaterMutationError = ErrorType<void>

    export const useInterventionsControllerRemoveInterventionFromSavedForLater = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof interventionsControllerRemoveInterventionFromSavedForLater>>, TError,{patientId: string;interventionId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof interventionsControllerRemoveInterventionFromSavedForLater>>,
        TError,
        {patientId: string;interventionId: string},
        TContext
      > => {

      const mutationOptions = getInterventionsControllerRemoveInterventionFromSavedForLaterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientInterventionsControllerGetAllPatientInterventions = (
    patientId: string,
    params?: PatientInterventionsControllerGetAllPatientInterventionsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientInterventionDto[]>(
      {url: `/v1/clinician-api/patient/${patientId}/patient-interventions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPatientInterventionsControllerGetAllPatientInterventionsQueryKey = (patientId: string,
    params?: PatientInterventionsControllerGetAllPatientInterventionsParams,) => {
    return [`/v1/clinician-api/patient/${patientId}/patient-interventions`, ...(params ? [params]: [])] as const;
    }

    
export const getPatientInterventionsControllerGetAllPatientInterventionsQueryOptions = <TData = Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>, TError = ErrorType<void>>(patientId: string,
    params?: PatientInterventionsControllerGetAllPatientInterventionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientInterventionsControllerGetAllPatientInterventionsQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>> = ({ signal }) => patientInterventionsControllerGetAllPatientInterventions(patientId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientInterventionsControllerGetAllPatientInterventionsQueryResult = NonNullable<Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>>
export type PatientInterventionsControllerGetAllPatientInterventionsQueryError = ErrorType<void>



export function usePatientInterventionsControllerGetAllPatientInterventions<TData = Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>, TError = ErrorType<void>>(
 patientId: string,
    params?: PatientInterventionsControllerGetAllPatientInterventionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientInterventionsControllerGetAllPatientInterventions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientInterventionsControllerGetAllPatientInterventionsQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientInterventionsControllerCreatePatientIntervention = (
    patientId: string,
    postPatientInterventionDto: PostPatientInterventionDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/patient-interventions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPatientInterventionDto, signal
    },
      );
    }
  


export const getPatientInterventionsControllerCreatePatientInterventionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerCreatePatientIntervention>>, TError,{patientId: string;data: PostPatientInterventionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerCreatePatientIntervention>>, TError,{patientId: string;data: PostPatientInterventionDto}, TContext> => {

const mutationKey = ['patientInterventionsControllerCreatePatientIntervention'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientInterventionsControllerCreatePatientIntervention>>, {patientId: string;data: PostPatientInterventionDto}> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientInterventionsControllerCreatePatientIntervention(patientId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientInterventionsControllerCreatePatientInterventionMutationResult = NonNullable<Awaited<ReturnType<typeof patientInterventionsControllerCreatePatientIntervention>>>
    export type PatientInterventionsControllerCreatePatientInterventionMutationBody = PostPatientInterventionDto
    export type PatientInterventionsControllerCreatePatientInterventionMutationError = ErrorType<void>

    export const usePatientInterventionsControllerCreatePatientIntervention = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerCreatePatientIntervention>>, TError,{patientId: string;data: PostPatientInterventionDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientInterventionsControllerCreatePatientIntervention>>,
        TError,
        {patientId: string;data: PostPatientInterventionDto},
        TContext
      > => {

      const mutationOptions = getPatientInterventionsControllerCreatePatientInterventionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientInterventionsControllerGetPatientInterventionById = (
    patientId: string,
    patientInterventionId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<PatientInterventionWithResponsesDto>(
      {url: `/v1/clinician-api/patient/${patientId}/patient-interventions/${patientInterventionId}/responses`, method: 'GET', signal
    },
      );
    }
  

export const getPatientInterventionsControllerGetPatientInterventionByIdQueryKey = (patientId: string,
    patientInterventionId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/patient-interventions/${patientInterventionId}/responses`] as const;
    }

    
export const getPatientInterventionsControllerGetPatientInterventionByIdQueryOptions = <TData = Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>, TError = ErrorType<void>>(patientId: string,
    patientInterventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientInterventionsControllerGetPatientInterventionByIdQueryKey(patientId,patientInterventionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>> = ({ signal }) => patientInterventionsControllerGetPatientInterventionById(patientId,patientInterventionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && patientInterventionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientInterventionsControllerGetPatientInterventionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>>
export type PatientInterventionsControllerGetPatientInterventionByIdQueryError = ErrorType<void>



export function usePatientInterventionsControllerGetPatientInterventionById<TData = Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>, TError = ErrorType<void>>(
 patientId: string,
    patientInterventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof patientInterventionsControllerGetPatientInterventionById>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPatientInterventionsControllerGetPatientInterventionByIdQueryOptions(patientId,patientInterventionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const patientInterventionsControllerUpdatePatientIntervention = (
    patientId: string,
    patientInterventionId: string,
    putPatientInterventionDto: PutPatientInterventionDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/patient-interventions/${patientInterventionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putPatientInterventionDto
    },
      );
    }
  


export const getPatientInterventionsControllerUpdatePatientInterventionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerUpdatePatientIntervention>>, TError,{patientId: string;patientInterventionId: string;data: PutPatientInterventionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerUpdatePatientIntervention>>, TError,{patientId: string;patientInterventionId: string;data: PutPatientInterventionDto}, TContext> => {

const mutationKey = ['patientInterventionsControllerUpdatePatientIntervention'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientInterventionsControllerUpdatePatientIntervention>>, {patientId: string;patientInterventionId: string;data: PutPatientInterventionDto}> = (props) => {
          const {patientId,patientInterventionId,data} = props ?? {};

          return  patientInterventionsControllerUpdatePatientIntervention(patientId,patientInterventionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientInterventionsControllerUpdatePatientInterventionMutationResult = NonNullable<Awaited<ReturnType<typeof patientInterventionsControllerUpdatePatientIntervention>>>
    export type PatientInterventionsControllerUpdatePatientInterventionMutationBody = PutPatientInterventionDto
    export type PatientInterventionsControllerUpdatePatientInterventionMutationError = ErrorType<void>

    export const usePatientInterventionsControllerUpdatePatientIntervention = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerUpdatePatientIntervention>>, TError,{patientId: string;patientInterventionId: string;data: PutPatientInterventionDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientInterventionsControllerUpdatePatientIntervention>>,
        TError,
        {patientId: string;patientInterventionId: string;data: PutPatientInterventionDto},
        TContext
      > => {

      const mutationOptions = getPatientInterventionsControllerUpdatePatientInterventionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const patientInterventionsControllerDeletePatientIntervention = (
    patientId: string,
    patientInterventionId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/patient-interventions/${patientInterventionId}`, method: 'DELETE'
    },
      );
    }
  


export const getPatientInterventionsControllerDeletePatientInterventionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerDeletePatientIntervention>>, TError,{patientId: string;patientInterventionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerDeletePatientIntervention>>, TError,{patientId: string;patientInterventionId: string}, TContext> => {

const mutationKey = ['patientInterventionsControllerDeletePatientIntervention'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientInterventionsControllerDeletePatientIntervention>>, {patientId: string;patientInterventionId: string}> = (props) => {
          const {patientId,patientInterventionId} = props ?? {};

          return  patientInterventionsControllerDeletePatientIntervention(patientId,patientInterventionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientInterventionsControllerDeletePatientInterventionMutationResult = NonNullable<Awaited<ReturnType<typeof patientInterventionsControllerDeletePatientIntervention>>>
    
    export type PatientInterventionsControllerDeletePatientInterventionMutationError = ErrorType<void>

    export const usePatientInterventionsControllerDeletePatientIntervention = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientInterventionsControllerDeletePatientIntervention>>, TError,{patientId: string;patientInterventionId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientInterventionsControllerDeletePatientIntervention>>,
        TError,
        {patientId: string;patientInterventionId: string},
        TContext
      > => {

      const mutationOptions = getPatientInterventionsControllerDeletePatientInterventionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const dischargeSummariesControllerGenerateDischargeSummary = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/discharge-summaries`, method: 'POST', signal
    },
      );
    }
  


export const getDischargeSummariesControllerGenerateDischargeSummaryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerGenerateDischargeSummary>>, TError,{patientId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerGenerateDischargeSummary>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['dischargeSummariesControllerGenerateDischargeSummary'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dischargeSummariesControllerGenerateDischargeSummary>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  dischargeSummariesControllerGenerateDischargeSummary(patientId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DischargeSummariesControllerGenerateDischargeSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof dischargeSummariesControllerGenerateDischargeSummary>>>
    
    export type DischargeSummariesControllerGenerateDischargeSummaryMutationError = ErrorType<void>

    export const useDischargeSummariesControllerGenerateDischargeSummary = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerGenerateDischargeSummary>>, TError,{patientId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof dischargeSummariesControllerGenerateDischargeSummary>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getDischargeSummariesControllerGenerateDischargeSummaryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const dischargeSummariesControllerGetDischargeSummaries = (
    patientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<DischargeSummaryDto[]>(
      {url: `/v1/clinician-api/patient/${patientId}/discharge-summaries`, method: 'GET', signal
    },
      );
    }
  

export const getDischargeSummariesControllerGetDischargeSummariesQueryKey = (patientId: string,) => {
    return [`/v1/clinician-api/patient/${patientId}/discharge-summaries`] as const;
    }

    
export const getDischargeSummariesControllerGetDischargeSummariesQueryOptions = <TData = Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>, TError = ErrorType<void>>(patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDischargeSummariesControllerGetDischargeSummariesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>> = ({ signal }) => dischargeSummariesControllerGetDischargeSummaries(patientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>, TError, TData> & { queryKey: QueryKey }
}

export type DischargeSummariesControllerGetDischargeSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>>
export type DischargeSummariesControllerGetDischargeSummariesQueryError = ErrorType<void>



export function useDischargeSummariesControllerGetDischargeSummaries<TData = Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>, TError = ErrorType<void>>(
 patientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dischargeSummariesControllerGetDischargeSummaries>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDischargeSummariesControllerGetDischargeSummariesQueryOptions(patientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const dischargeSummariesControllerUpdateDischargeSummary = (
    patientId: string,
    dischargeSummaryId: string,
    patchDischargeSummaryDto: PatchDischargeSummaryDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/discharge-summaries/${dischargeSummaryId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchDischargeSummaryDto
    },
      );
    }
  


export const getDischargeSummariesControllerUpdateDischargeSummaryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerUpdateDischargeSummary>>, TError,{patientId: string;dischargeSummaryId: string;data: PatchDischargeSummaryDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerUpdateDischargeSummary>>, TError,{patientId: string;dischargeSummaryId: string;data: PatchDischargeSummaryDto}, TContext> => {

const mutationKey = ['dischargeSummariesControllerUpdateDischargeSummary'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dischargeSummariesControllerUpdateDischargeSummary>>, {patientId: string;dischargeSummaryId: string;data: PatchDischargeSummaryDto}> = (props) => {
          const {patientId,dischargeSummaryId,data} = props ?? {};

          return  dischargeSummariesControllerUpdateDischargeSummary(patientId,dischargeSummaryId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DischargeSummariesControllerUpdateDischargeSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof dischargeSummariesControllerUpdateDischargeSummary>>>
    export type DischargeSummariesControllerUpdateDischargeSummaryMutationBody = PatchDischargeSummaryDto
    export type DischargeSummariesControllerUpdateDischargeSummaryMutationError = ErrorType<void>

    export const useDischargeSummariesControllerUpdateDischargeSummary = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerUpdateDischargeSummary>>, TError,{patientId: string;dischargeSummaryId: string;data: PatchDischargeSummaryDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof dischargeSummariesControllerUpdateDischargeSummary>>,
        TError,
        {patientId: string;dischargeSummaryId: string;data: PatchDischargeSummaryDto},
        TContext
      > => {

      const mutationOptions = getDischargeSummariesControllerUpdateDischargeSummaryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const dischargeSummariesControllerDeleteDischargeSummary = (
    patientId: string,
    dischargeSummaryId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/patient/${patientId}/discharge-summaries/${dischargeSummaryId}`, method: 'DELETE'
    },
      );
    }
  


export const getDischargeSummariesControllerDeleteDischargeSummaryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerDeleteDischargeSummary>>, TError,{patientId: string;dischargeSummaryId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerDeleteDischargeSummary>>, TError,{patientId: string;dischargeSummaryId: string}, TContext> => {

const mutationKey = ['dischargeSummariesControllerDeleteDischargeSummary'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dischargeSummariesControllerDeleteDischargeSummary>>, {patientId: string;dischargeSummaryId: string}> = (props) => {
          const {patientId,dischargeSummaryId} = props ?? {};

          return  dischargeSummariesControllerDeleteDischargeSummary(patientId,dischargeSummaryId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DischargeSummariesControllerDeleteDischargeSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof dischargeSummariesControllerDeleteDischargeSummary>>>
    
    export type DischargeSummariesControllerDeleteDischargeSummaryMutationError = ErrorType<void>

    export const useDischargeSummariesControllerDeleteDischargeSummary = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dischargeSummariesControllerDeleteDischargeSummary>>, TError,{patientId: string;dischargeSummaryId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof dischargeSummariesControllerDeleteDischargeSummary>>,
        TError,
        {patientId: string;dischargeSummaryId: string},
        TContext
      > => {

      const mutationOptions = getDischargeSummariesControllerDeleteDischargeSummaryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const checkinsControllerV1GetAllCheckIns = (
    params?: CheckinsControllerV1GetAllCheckInsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckInDtoV2[]>(
      {url: `/v1/clinician-api/library/check-ins/all`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCheckinsControllerV1GetAllCheckInsQueryKey = (params?: CheckinsControllerV1GetAllCheckInsParams,) => {
    return [`/v1/clinician-api/library/check-ins/all`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckinsControllerV1GetAllCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>, TError = ErrorType<void>>(params?: CheckinsControllerV1GetAllCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckinsControllerV1GetAllCheckInsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>> = ({ signal }) => checkinsControllerV1GetAllCheckIns(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckinsControllerV1GetAllCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>>
export type CheckinsControllerV1GetAllCheckInsQueryError = ErrorType<void>



export function useCheckinsControllerV1GetAllCheckIns<TData = Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>, TError = ErrorType<void>>(
 params?: CheckinsControllerV1GetAllCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkinsControllerV1GetAllCheckIns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckinsControllerV1GetAllCheckInsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const checkinsControllerV1GetDraftCheckIn = (
    checkInId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckInDtoV2>(
      {url: `/v1/clinician-api/library/check-ins/${checkInId}/draft`, method: 'GET', signal
    },
      );
    }
  

export const getCheckinsControllerV1GetDraftCheckInQueryKey = (checkInId: string,) => {
    return [`/v1/clinician-api/library/check-ins/${checkInId}/draft`] as const;
    }

    
export const getCheckinsControllerV1GetDraftCheckInQueryOptions = <TData = Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>, TError = ErrorType<void>>(checkInId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckinsControllerV1GetDraftCheckInQueryKey(checkInId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>> = ({ signal }) => checkinsControllerV1GetDraftCheckIn(checkInId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(checkInId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckinsControllerV1GetDraftCheckInQueryResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>>
export type CheckinsControllerV1GetDraftCheckInQueryError = ErrorType<void>



export function useCheckinsControllerV1GetDraftCheckIn<TData = Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>, TError = ErrorType<void>>(
 checkInId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkinsControllerV1GetDraftCheckIn>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckinsControllerV1GetDraftCheckInQueryOptions(checkInId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const checkinsControllerV1SaveDraftCheckIn = (
    checkInId: string,
    checkInBodyDto: CheckInBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/library/check-ins/${checkInId}/draft`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkInBodyDto, signal
    },
      );
    }
  


export const getCheckinsControllerV1SaveDraftCheckInMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1SaveDraftCheckIn>>, TError,{checkInId: string;data: CheckInBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1SaveDraftCheckIn>>, TError,{checkInId: string;data: CheckInBodyDto}, TContext> => {

const mutationKey = ['checkinsControllerV1SaveDraftCheckIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkinsControllerV1SaveDraftCheckIn>>, {checkInId: string;data: CheckInBodyDto}> = (props) => {
          const {checkInId,data} = props ?? {};

          return  checkinsControllerV1SaveDraftCheckIn(checkInId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckinsControllerV1SaveDraftCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1SaveDraftCheckIn>>>
    export type CheckinsControllerV1SaveDraftCheckInMutationBody = CheckInBodyDto
    export type CheckinsControllerV1SaveDraftCheckInMutationError = ErrorType<void>

    export const useCheckinsControllerV1SaveDraftCheckIn = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1SaveDraftCheckIn>>, TError,{checkInId: string;data: CheckInBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkinsControllerV1SaveDraftCheckIn>>,
        TError,
        {checkInId: string;data: CheckInBodyDto},
        TContext
      > => {

      const mutationOptions = getCheckinsControllerV1SaveDraftCheckInMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const checkinsControllerV1CreateCheckIn = (
    checkInBodyDto: CheckInBodyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckInDtoV2>(
      {url: `/v1/clinician-api/library/check-ins/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkInBodyDto, signal
    },
      );
    }
  


export const getCheckinsControllerV1CreateCheckInMutationOptions = <TError = ErrorType<void | CheckInDtoV2>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1CreateCheckIn>>, TError,{data: CheckInBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1CreateCheckIn>>, TError,{data: CheckInBodyDto}, TContext> => {

const mutationKey = ['checkinsControllerV1CreateCheckIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkinsControllerV1CreateCheckIn>>, {data: CheckInBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  checkinsControllerV1CreateCheckIn(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckinsControllerV1CreateCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1CreateCheckIn>>>
    export type CheckinsControllerV1CreateCheckInMutationBody = CheckInBodyDto
    export type CheckinsControllerV1CreateCheckInMutationError = ErrorType<void | CheckInDtoV2>

    export const useCheckinsControllerV1CreateCheckIn = <TError = ErrorType<void | CheckInDtoV2>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1CreateCheckIn>>, TError,{data: CheckInBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkinsControllerV1CreateCheckIn>>,
        TError,
        {data: CheckInBodyDto},
        TContext
      > => {

      const mutationOptions = getCheckinsControllerV1CreateCheckInMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const checkinsControllerV1PublishDraftCheckIn = (
    checkInId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/library/check-ins/${checkInId}/publish-draft`, method: 'POST', signal
    },
      );
    }
  


export const getCheckinsControllerV1PublishDraftCheckInMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1PublishDraftCheckIn>>, TError,{checkInId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1PublishDraftCheckIn>>, TError,{checkInId: string}, TContext> => {

const mutationKey = ['checkinsControllerV1PublishDraftCheckIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkinsControllerV1PublishDraftCheckIn>>, {checkInId: string}> = (props) => {
          const {checkInId} = props ?? {};

          return  checkinsControllerV1PublishDraftCheckIn(checkInId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckinsControllerV1PublishDraftCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1PublishDraftCheckIn>>>
    
    export type CheckinsControllerV1PublishDraftCheckInMutationError = ErrorType<void>

    export const useCheckinsControllerV1PublishDraftCheckIn = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1PublishDraftCheckIn>>, TError,{checkInId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkinsControllerV1PublishDraftCheckIn>>,
        TError,
        {checkInId: string},
        TContext
      > => {

      const mutationOptions = getCheckinsControllerV1PublishDraftCheckInMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const checkinsControllerV1ToggleCheckInIsCore = (
    checkInId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/library/check-ins/${checkInId}/toggle-core`, method: 'PUT'
    },
      );
    }
  


export const getCheckinsControllerV1ToggleCheckInIsCoreMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckInIsCore>>, TError,{checkInId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckInIsCore>>, TError,{checkInId: string}, TContext> => {

const mutationKey = ['checkinsControllerV1ToggleCheckInIsCore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckInIsCore>>, {checkInId: string}> = (props) => {
          const {checkInId} = props ?? {};

          return  checkinsControllerV1ToggleCheckInIsCore(checkInId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckinsControllerV1ToggleCheckInIsCoreMutationResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckInIsCore>>>
    
    export type CheckinsControllerV1ToggleCheckInIsCoreMutationError = ErrorType<void>

    export const useCheckinsControllerV1ToggleCheckInIsCore = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckInIsCore>>, TError,{checkInId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckInIsCore>>,
        TError,
        {checkInId: string},
        TContext
      > => {

      const mutationOptions = getCheckinsControllerV1ToggleCheckInIsCoreMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const checkinsControllerV1ToggleCheckinIsAssist = (
    checkInId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/library/check-ins/${checkInId}/toggle-assist`, method: 'PUT'
    },
      );
    }
  


export const getCheckinsControllerV1ToggleCheckinIsAssistMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckinIsAssist>>, TError,{checkInId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckinIsAssist>>, TError,{checkInId: string}, TContext> => {

const mutationKey = ['checkinsControllerV1ToggleCheckinIsAssist'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckinIsAssist>>, {checkInId: string}> = (props) => {
          const {checkInId} = props ?? {};

          return  checkinsControllerV1ToggleCheckinIsAssist(checkInId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckinsControllerV1ToggleCheckinIsAssistMutationResult = NonNullable<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckinIsAssist>>>
    
    export type CheckinsControllerV1ToggleCheckinIsAssistMutationError = ErrorType<void>

    export const useCheckinsControllerV1ToggleCheckinIsAssist = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckinIsAssist>>, TError,{checkInId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkinsControllerV1ToggleCheckinIsAssist>>,
        TError,
        {checkInId: string},
        TContext
      > => {

      const mutationOptions = getCheckinsControllerV1ToggleCheckinIsAssistMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const interventionsControllerV1GetAllInterventions = (
    params?: InterventionsControllerV1GetAllInterventionsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<Intervention[]>(
      {url: `/v1/clinician-api/library/interventions/all`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getInterventionsControllerV1GetAllInterventionsQueryKey = (params?: InterventionsControllerV1GetAllInterventionsParams,) => {
    return [`/v1/clinician-api/library/interventions/all`, ...(params ? [params]: [])] as const;
    }

    
export const getInterventionsControllerV1GetAllInterventionsQueryOptions = <TData = Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>, TError = ErrorType<void>>(params?: InterventionsControllerV1GetAllInterventionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInterventionsControllerV1GetAllInterventionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>> = ({ signal }) => interventionsControllerV1GetAllInterventions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>, TError, TData> & { queryKey: QueryKey }
}

export type InterventionsControllerV1GetAllInterventionsQueryResult = NonNullable<Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>>
export type InterventionsControllerV1GetAllInterventionsQueryError = ErrorType<void>



export function useInterventionsControllerV1GetAllInterventions<TData = Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>, TError = ErrorType<void>>(
 params?: InterventionsControllerV1GetAllInterventionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetAllInterventions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInterventionsControllerV1GetAllInterventionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const interventionsControllerV1GetIntervention = (
    interventionId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<Intervention>(
      {url: `/v1/clinician-api/library/interventions/${interventionId}`, method: 'GET', signal
    },
      );
    }
  

export const getInterventionsControllerV1GetInterventionQueryKey = (interventionId: string,) => {
    return [`/v1/clinician-api/library/interventions/${interventionId}`] as const;
    }

    
export const getInterventionsControllerV1GetInterventionQueryOptions = <TData = Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>, TError = ErrorType<void>>(interventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInterventionsControllerV1GetInterventionQueryKey(interventionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>> = ({ signal }) => interventionsControllerV1GetIntervention(interventionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(interventionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>, TError, TData> & { queryKey: QueryKey }
}

export type InterventionsControllerV1GetInterventionQueryResult = NonNullable<Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>>
export type InterventionsControllerV1GetInterventionQueryError = ErrorType<void>



export function useInterventionsControllerV1GetIntervention<TData = Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>, TError = ErrorType<void>>(
 interventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetIntervention>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInterventionsControllerV1GetInterventionQueryOptions(interventionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const interventionsControllerV1GetInterventionActivity = (
    interventionId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<Intervention>(
      {url: `/v1/clinician-api/library/interventions/${interventionId}/items`, method: 'GET', signal
    },
      );
    }
  

export const getInterventionsControllerV1GetInterventionActivityQueryKey = (interventionId: string,) => {
    return [`/v1/clinician-api/library/interventions/${interventionId}/items`] as const;
    }

    
export const getInterventionsControllerV1GetInterventionActivityQueryOptions = <TData = Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>, TError = ErrorType<void>>(interventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInterventionsControllerV1GetInterventionActivityQueryKey(interventionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>> = ({ signal }) => interventionsControllerV1GetInterventionActivity(interventionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(interventionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type InterventionsControllerV1GetInterventionActivityQueryResult = NonNullable<Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>>
export type InterventionsControllerV1GetInterventionActivityQueryError = ErrorType<void>



export function useInterventionsControllerV1GetInterventionActivity<TData = Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>, TError = ErrorType<void>>(
 interventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof interventionsControllerV1GetInterventionActivity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInterventionsControllerV1GetInterventionActivityQueryOptions(interventionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const contentSuggestionControllerDismiss = (
    contentSuggestionId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/content-suggestion/${contentSuggestionId}/dismiss`, method: 'PATCH'
    },
      );
    }
  


export const getContentSuggestionControllerDismissMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerDismiss>>, TError,{contentSuggestionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerDismiss>>, TError,{contentSuggestionId: string}, TContext> => {

const mutationKey = ['contentSuggestionControllerDismiss'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contentSuggestionControllerDismiss>>, {contentSuggestionId: string}> = (props) => {
          const {contentSuggestionId} = props ?? {};

          return  contentSuggestionControllerDismiss(contentSuggestionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContentSuggestionControllerDismissMutationResult = NonNullable<Awaited<ReturnType<typeof contentSuggestionControllerDismiss>>>
    
    export type ContentSuggestionControllerDismissMutationError = ErrorType<void>

    export const useContentSuggestionControllerDismiss = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerDismiss>>, TError,{contentSuggestionId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof contentSuggestionControllerDismiss>>,
        TError,
        {contentSuggestionId: string},
        TContext
      > => {

      const mutationOptions = getContentSuggestionControllerDismissMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const contentSuggestionControllerAccept = (
    contentSuggestionId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/content-suggestion/${contentSuggestionId}/accept`, method: 'PATCH'
    },
      );
    }
  


export const getContentSuggestionControllerAcceptMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerAccept>>, TError,{contentSuggestionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerAccept>>, TError,{contentSuggestionId: string}, TContext> => {

const mutationKey = ['contentSuggestionControllerAccept'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contentSuggestionControllerAccept>>, {contentSuggestionId: string}> = (props) => {
          const {contentSuggestionId} = props ?? {};

          return  contentSuggestionControllerAccept(contentSuggestionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContentSuggestionControllerAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof contentSuggestionControllerAccept>>>
    
    export type ContentSuggestionControllerAcceptMutationError = ErrorType<void>

    export const useContentSuggestionControllerAccept = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerAccept>>, TError,{contentSuggestionId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof contentSuggestionControllerAccept>>,
        TError,
        {contentSuggestionId: string},
        TContext
      > => {

      const mutationOptions = getContentSuggestionControllerAcceptMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const contentSuggestionControllerSubmitFeedback = (
    contentSuggestionId: string,
    submitFeedbackDto: SubmitFeedbackDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/content-suggestion/${contentSuggestionId}/feedback`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: submitFeedbackDto
    },
      );
    }
  


export const getContentSuggestionControllerSubmitFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerSubmitFeedback>>, TError,{contentSuggestionId: string;data: SubmitFeedbackDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerSubmitFeedback>>, TError,{contentSuggestionId: string;data: SubmitFeedbackDto}, TContext> => {

const mutationKey = ['contentSuggestionControllerSubmitFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contentSuggestionControllerSubmitFeedback>>, {contentSuggestionId: string;data: SubmitFeedbackDto}> = (props) => {
          const {contentSuggestionId,data} = props ?? {};

          return  contentSuggestionControllerSubmitFeedback(contentSuggestionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContentSuggestionControllerSubmitFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof contentSuggestionControllerSubmitFeedback>>>
    export type ContentSuggestionControllerSubmitFeedbackMutationBody = SubmitFeedbackDto
    export type ContentSuggestionControllerSubmitFeedbackMutationError = ErrorType<void>

    export const useContentSuggestionControllerSubmitFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contentSuggestionControllerSubmitFeedback>>, TError,{contentSuggestionId: string;data: SubmitFeedbackDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof contentSuggestionControllerSubmitFeedback>>,
        TError,
        {contentSuggestionId: string;data: SubmitFeedbackDto},
        TContext
      > => {

      const mutationOptions = getContentSuggestionControllerSubmitFeedbackMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerGetOrganizationConsentSetting = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ConsentSettingDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/consent-setting`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetOrganizationConsentSettingQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/consent-setting`] as const;
    }

    
export const getOrganizationControllerGetOrganizationConsentSettingQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetOrganizationConsentSettingQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>> = ({ signal }) => organizationControllerGetOrganizationConsentSetting(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetOrganizationConsentSettingQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>>
export type OrganizationControllerGetOrganizationConsentSettingQueryError = ErrorType<void>



export function useOrganizationControllerGetOrganizationConsentSetting<TData = Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOrganizationConsentSetting>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetOrganizationConsentSettingQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerUpdateOrganizationConsentSetting = (
    organizationId: string,
    patchConsentSettingDTO: PatchConsentSettingDTO,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/organization/${organizationId}/consent-setting`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchConsentSettingDTO
    },
      );
    }
  


export const getOrganizationControllerUpdateOrganizationConsentSettingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateOrganizationConsentSetting>>, TError,{organizationId: string;data: PatchConsentSettingDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateOrganizationConsentSetting>>, TError,{organizationId: string;data: PatchConsentSettingDTO}, TContext> => {

const mutationKey = ['organizationControllerUpdateOrganizationConsentSetting'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdateOrganizationConsentSetting>>, {organizationId: string;data: PatchConsentSettingDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerUpdateOrganizationConsentSetting(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateOrganizationConsentSettingMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdateOrganizationConsentSetting>>>
    export type OrganizationControllerUpdateOrganizationConsentSettingMutationBody = PatchConsentSettingDTO
    export type OrganizationControllerUpdateOrganizationConsentSettingMutationError = ErrorType<void>

    export const useOrganizationControllerUpdateOrganizationConsentSetting = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateOrganizationConsentSetting>>, TError,{organizationId: string;data: PatchConsentSettingDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdateOrganizationConsentSetting>>,
        TError,
        {organizationId: string;data: PatchConsentSettingDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateOrganizationConsentSettingMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerCreateCustomProgressNoteTemplate = (
    organizationId: string,
    createCustomProgressNoteTemplateDTO: CreateCustomProgressNoteTemplateDTO,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/organization/${organizationId}/custom-progress-note-templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomProgressNoteTemplateDTO, signal
    },
      );
    }
  


export const getOrganizationControllerCreateCustomProgressNoteTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateCustomProgressNoteTemplate>>, TError,{organizationId: string;data: CreateCustomProgressNoteTemplateDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateCustomProgressNoteTemplate>>, TError,{organizationId: string;data: CreateCustomProgressNoteTemplateDTO}, TContext> => {

const mutationKey = ['organizationControllerCreateCustomProgressNoteTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerCreateCustomProgressNoteTemplate>>, {organizationId: string;data: CreateCustomProgressNoteTemplateDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerCreateCustomProgressNoteTemplate(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerCreateCustomProgressNoteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerCreateCustomProgressNoteTemplate>>>
    export type OrganizationControllerCreateCustomProgressNoteTemplateMutationBody = CreateCustomProgressNoteTemplateDTO
    export type OrganizationControllerCreateCustomProgressNoteTemplateMutationError = ErrorType<void>

    export const useOrganizationControllerCreateCustomProgressNoteTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateCustomProgressNoteTemplate>>, TError,{organizationId: string;data: CreateCustomProgressNoteTemplateDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerCreateCustomProgressNoteTemplate>>,
        TError,
        {organizationId: string;data: CreateCustomProgressNoteTemplateDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerCreateCustomProgressNoteTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerGetCustomProgressNoteTemplates = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CustomProgressNoteTemplateDTO[]>(
      {url: `/v1/clinician-api/organization/${organizationId}/custom-progress-note-templates`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetCustomProgressNoteTemplatesQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/custom-progress-note-templates`] as const;
    }

    
export const getOrganizationControllerGetCustomProgressNoteTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetCustomProgressNoteTemplatesQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>> = ({ signal }) => organizationControllerGetCustomProgressNoteTemplates(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetCustomProgressNoteTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>>
export type OrganizationControllerGetCustomProgressNoteTemplatesQueryError = ErrorType<void>



export function useOrganizationControllerGetCustomProgressNoteTemplates<TData = Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetCustomProgressNoteTemplatesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerGetOutboundEhrSettings = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<OutboundEhrSettingsDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/outbound-ehr-settings`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetOutboundEhrSettingsQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/outbound-ehr-settings`] as const;
    }

    
export const getOrganizationControllerGetOutboundEhrSettingsQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetOutboundEhrSettingsQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>> = ({ signal }) => organizationControllerGetOutboundEhrSettings(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetOutboundEhrSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>>
export type OrganizationControllerGetOutboundEhrSettingsQueryError = ErrorType<void>



export function useOrganizationControllerGetOutboundEhrSettings<TData = Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOutboundEhrSettings>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetOutboundEhrSettingsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerGetCustomProgressNoteTemplate = (
    organizationId: string,
    templateId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CustomProgressNoteTemplateDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/custom-progress-note-templates/${templateId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetCustomProgressNoteTemplateQueryKey = (organizationId: string,
    templateId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/custom-progress-note-templates/${templateId}`] as const;
    }

    
export const getOrganizationControllerGetCustomProgressNoteTemplateQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>, TError = ErrorType<void>>(organizationId: string,
    templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetCustomProgressNoteTemplateQueryKey(organizationId,templateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>> = ({ signal }) => organizationControllerGetCustomProgressNoteTemplate(organizationId,templateId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && templateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetCustomProgressNoteTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>>
export type OrganizationControllerGetCustomProgressNoteTemplateQueryError = ErrorType<void>



export function useOrganizationControllerGetCustomProgressNoteTemplate<TData = Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>, TError = ErrorType<void>>(
 organizationId: string,
    templateId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetCustomProgressNoteTemplate>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetCustomProgressNoteTemplateQueryOptions(organizationId,templateId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerDeleteCustomProgressNoteTemplate = (
    organizationId: string,
    templateId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/organization/${organizationId}/custom-progress-note-templates/${templateId}`, method: 'DELETE'
    },
      );
    }
  


export const getOrganizationControllerDeleteCustomProgressNoteTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerDeleteCustomProgressNoteTemplate>>, TError,{organizationId: string;templateId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerDeleteCustomProgressNoteTemplate>>, TError,{organizationId: string;templateId: string}, TContext> => {

const mutationKey = ['organizationControllerDeleteCustomProgressNoteTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerDeleteCustomProgressNoteTemplate>>, {organizationId: string;templateId: string}> = (props) => {
          const {organizationId,templateId} = props ?? {};

          return  organizationControllerDeleteCustomProgressNoteTemplate(organizationId,templateId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerDeleteCustomProgressNoteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerDeleteCustomProgressNoteTemplate>>>
    
    export type OrganizationControllerDeleteCustomProgressNoteTemplateMutationError = ErrorType<void>

    export const useOrganizationControllerDeleteCustomProgressNoteTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerDeleteCustomProgressNoteTemplate>>, TError,{organizationId: string;templateId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerDeleteCustomProgressNoteTemplate>>,
        TError,
        {organizationId: string;templateId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerDeleteCustomProgressNoteTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerGetOrganizationPreferences = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<OrganizationControllerGetOrganizationPreferences200>(
      {url: `/v1/clinician-api/organization/${organizationId}/preferences`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetOrganizationPreferencesQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/preferences`] as const;
    }

    
export const getOrganizationControllerGetOrganizationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetOrganizationPreferencesQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>> = ({ signal }) => organizationControllerGetOrganizationPreferences(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetOrganizationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>>
export type OrganizationControllerGetOrganizationPreferencesQueryError = ErrorType<void>



export function useOrganizationControllerGetOrganizationPreferences<TData = Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOrganizationPreferences>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetOrganizationPreferencesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerGetSessionCredit = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionCreditDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/session-credits`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetSessionCreditQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/session-credits`] as const;
    }

    
export const getOrganizationControllerGetSessionCreditQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetSessionCreditQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>> = ({ signal }) => organizationControllerGetSessionCredit(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetSessionCreditQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>>
export type OrganizationControllerGetSessionCreditQueryError = ErrorType<void>



export function useOrganizationControllerGetSessionCredit<TData = Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetSessionCredit>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetSessionCreditQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerPurchaseSessionCredits = (
    organizationId: string,
    purchaseSessionCreditsRequestDto: PurchaseSessionCreditsRequestDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionCreditDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/session-credits/purchase`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: purchaseSessionCreditsRequestDto, signal
    },
      );
    }
  


export const getOrganizationControllerPurchaseSessionCreditsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerPurchaseSessionCredits>>, TError,{organizationId: string;data: PurchaseSessionCreditsRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerPurchaseSessionCredits>>, TError,{organizationId: string;data: PurchaseSessionCreditsRequestDto}, TContext> => {

const mutationKey = ['organizationControllerPurchaseSessionCredits'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerPurchaseSessionCredits>>, {organizationId: string;data: PurchaseSessionCreditsRequestDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerPurchaseSessionCredits(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerPurchaseSessionCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerPurchaseSessionCredits>>>
    export type OrganizationControllerPurchaseSessionCreditsMutationBody = PurchaseSessionCreditsRequestDto
    export type OrganizationControllerPurchaseSessionCreditsMutationError = ErrorType<void>

    export const useOrganizationControllerPurchaseSessionCredits = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerPurchaseSessionCredits>>, TError,{organizationId: string;data: PurchaseSessionCreditsRequestDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerPurchaseSessionCredits>>,
        TError,
        {organizationId: string;data: PurchaseSessionCreditsRequestDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerPurchaseSessionCreditsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerChangePlan = (
    organizationId: string,
    changePlanRequestDto: ChangePlanRequestDto,
 ) => {
      
      
      return hellojoyApiInstance<ChangePlanResponseDto>(
      {url: `/v1/clinician-api/organization/${organizationId}/session-credits/change-plan`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changePlanRequestDto
    },
      );
    }
  


export const getOrganizationControllerChangePlanMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerChangePlan>>, TError,{organizationId: string;data: ChangePlanRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerChangePlan>>, TError,{organizationId: string;data: ChangePlanRequestDto}, TContext> => {

const mutationKey = ['organizationControllerChangePlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerChangePlan>>, {organizationId: string;data: ChangePlanRequestDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerChangePlan(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerChangePlanMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerChangePlan>>>
    export type OrganizationControllerChangePlanMutationBody = ChangePlanRequestDto
    export type OrganizationControllerChangePlanMutationError = ErrorType<void>

    export const useOrganizationControllerChangePlan = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerChangePlan>>, TError,{organizationId: string;data: ChangePlanRequestDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerChangePlan>>,
        TError,
        {organizationId: string;data: ChangePlanRequestDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerChangePlanMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerUpdateAutoReplenishSettings = (
    organizationId: string,
    updateAutoReplenishDto: UpdateAutoReplenishDto,
 ) => {
      
      
      return hellojoyApiInstance<SessionCreditDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/session-credits/auto-replenish`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAutoReplenishDto
    },
      );
    }
  


export const getOrganizationControllerUpdateAutoReplenishSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateAutoReplenishSettings>>, TError,{organizationId: string;data: UpdateAutoReplenishDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateAutoReplenishSettings>>, TError,{organizationId: string;data: UpdateAutoReplenishDto}, TContext> => {

const mutationKey = ['organizationControllerUpdateAutoReplenishSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdateAutoReplenishSettings>>, {organizationId: string;data: UpdateAutoReplenishDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerUpdateAutoReplenishSettings(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateAutoReplenishSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdateAutoReplenishSettings>>>
    export type OrganizationControllerUpdateAutoReplenishSettingsMutationBody = UpdateAutoReplenishDto
    export type OrganizationControllerUpdateAutoReplenishSettingsMutationError = ErrorType<void>

    export const useOrganizationControllerUpdateAutoReplenishSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateAutoReplenishSettings>>, TError,{organizationId: string;data: UpdateAutoReplenishDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdateAutoReplenishSettings>>,
        TError,
        {organizationId: string;data: UpdateAutoReplenishDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateAutoReplenishSettingsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerUpdateBillingEmail = (
    organizationId: string,
    updateBillingEmailDto: UpdateBillingEmailDto,
 ) => {
      
      
      return hellojoyApiInstance<SessionCreditDTO>(
      {url: `/v1/clinician-api/organization/${organizationId}/session-credits/billing-email`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateBillingEmailDto
    },
      );
    }
  


export const getOrganizationControllerUpdateBillingEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateBillingEmail>>, TError,{organizationId: string;data: UpdateBillingEmailDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateBillingEmail>>, TError,{organizationId: string;data: UpdateBillingEmailDto}, TContext> => {

const mutationKey = ['organizationControllerUpdateBillingEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdateBillingEmail>>, {organizationId: string;data: UpdateBillingEmailDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerUpdateBillingEmail(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateBillingEmailMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdateBillingEmail>>>
    export type OrganizationControllerUpdateBillingEmailMutationBody = UpdateBillingEmailDto
    export type OrganizationControllerUpdateBillingEmailMutationError = ErrorType<void>

    export const useOrganizationControllerUpdateBillingEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateBillingEmail>>, TError,{organizationId: string;data: UpdateBillingEmailDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdateBillingEmail>>,
        TError,
        {organizationId: string;data: UpdateBillingEmailDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateBillingEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerSessionCreditsPaymentMethod = (
    organizationId: string,
    sessionCreditsPaymentMethodRequestDto: SessionCreditsPaymentMethodRequestDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionCreditsPaymentMethodResponseDto>(
      {url: `/v1/clinician-api/organization/${organizationId}/session-credits/payment-method`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionCreditsPaymentMethodRequestDto, signal
    },
      );
    }
  


export const getOrganizationControllerSessionCreditsPaymentMethodMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerSessionCreditsPaymentMethod>>, TError,{organizationId: string;data: SessionCreditsPaymentMethodRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerSessionCreditsPaymentMethod>>, TError,{organizationId: string;data: SessionCreditsPaymentMethodRequestDto}, TContext> => {

const mutationKey = ['organizationControllerSessionCreditsPaymentMethod'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerSessionCreditsPaymentMethod>>, {organizationId: string;data: SessionCreditsPaymentMethodRequestDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerSessionCreditsPaymentMethod(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerSessionCreditsPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerSessionCreditsPaymentMethod>>>
    export type OrganizationControllerSessionCreditsPaymentMethodMutationBody = SessionCreditsPaymentMethodRequestDto
    export type OrganizationControllerSessionCreditsPaymentMethodMutationError = ErrorType<void>

    export const useOrganizationControllerSessionCreditsPaymentMethod = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerSessionCreditsPaymentMethod>>, TError,{organizationId: string;data: SessionCreditsPaymentMethodRequestDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerSessionCreditsPaymentMethod>>,
        TError,
        {organizationId: string;data: SessionCreditsPaymentMethodRequestDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerSessionCreditsPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerCreateStripeConnectAccount = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CreateStripeConnectAccountResponseDto>(
      {url: `/v1/clinician-api/organization/${organizationId}/create-stripe-connect-account`, method: 'POST', signal
    },
      );
    }
  


export const getOrganizationControllerCreateStripeConnectAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccount>>, TError,{organizationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccount>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['organizationControllerCreateStripeConnectAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccount>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  organizationControllerCreateStripeConnectAccount(organizationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerCreateStripeConnectAccountMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccount>>>
    
    export type OrganizationControllerCreateStripeConnectAccountMutationError = ErrorType<void>

    export const useOrganizationControllerCreateStripeConnectAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccount>>, TError,{organizationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccount>>,
        TError,
        {organizationId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerCreateStripeConnectAccountMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerCreateStripeConnectAccountLink = (
    organizationId: string,
    createStripeConnectAccountLinkRequestDto: CreateStripeConnectAccountLinkRequestDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CreateStripeConnectAccountLinkResponseDto>(
      {url: `/v1/clinician-api/organization/${organizationId}/create-stripe-connect-account-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStripeConnectAccountLinkRequestDto, signal
    },
      );
    }
  


export const getOrganizationControllerCreateStripeConnectAccountLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccountLink>>, TError,{organizationId: string;data: CreateStripeConnectAccountLinkRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccountLink>>, TError,{organizationId: string;data: CreateStripeConnectAccountLinkRequestDto}, TContext> => {

const mutationKey = ['organizationControllerCreateStripeConnectAccountLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccountLink>>, {organizationId: string;data: CreateStripeConnectAccountLinkRequestDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerCreateStripeConnectAccountLink(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerCreateStripeConnectAccountLinkMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccountLink>>>
    export type OrganizationControllerCreateStripeConnectAccountLinkMutationBody = CreateStripeConnectAccountLinkRequestDto
    export type OrganizationControllerCreateStripeConnectAccountLinkMutationError = ErrorType<void>

    export const useOrganizationControllerCreateStripeConnectAccountLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccountLink>>, TError,{organizationId: string;data: CreateStripeConnectAccountLinkRequestDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerCreateStripeConnectAccountLink>>,
        TError,
        {organizationId: string;data: CreateStripeConnectAccountLinkRequestDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerCreateStripeConnectAccountLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const organizationControllerCheckStripeConnectOnboardingStatus = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckStripeConnectOnboardingStatusResponseDto>(
      {url: `/v1/clinician-api/organization/${organizationId}/check-stripe-connect-onboarding-status`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerCheckStripeConnectOnboardingStatusQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/check-stripe-connect-onboarding-status`] as const;
    }

    
export const getOrganizationControllerCheckStripeConnectOnboardingStatusQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerCheckStripeConnectOnboardingStatusQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>> = ({ signal }) => organizationControllerCheckStripeConnectOnboardingStatus(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerCheckStripeConnectOnboardingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>>
export type OrganizationControllerCheckStripeConnectOnboardingStatusQueryError = ErrorType<void>



export function useOrganizationControllerCheckStripeConnectOnboardingStatus<TData = Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerCheckStripeConnectOnboardingStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerCheckStripeConnectOnboardingStatusQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerGetInvoices = (
    organizationId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SessionUsageInvoiceDTO[]>(
      {url: `/v1/clinician-api/organization/${organizationId}/invoices`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationControllerGetInvoicesQueryKey = (organizationId: string,) => {
    return [`/v1/clinician-api/organization/${organizationId}/invoices`] as const;
    }

    
export const getOrganizationControllerGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetInvoices>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetInvoices>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetInvoicesQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetInvoices>>> = ({ signal }) => organizationControllerGetInvoices(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetInvoices>>>
export type OrganizationControllerGetInvoicesQueryError = ErrorType<void>



export function useOrganizationControllerGetInvoices<TData = Awaited<ReturnType<typeof organizationControllerGetInvoices>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetInvoices>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOrganizationControllerGetInvoicesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const checkInControllerGetCheckInsForPlusCustomer = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CheckInDtoV2[]>(
      {url: `/v1/clinician-api/check-in`, method: 'GET', signal
    },
      );
    }
  

export const getCheckInControllerGetCheckInsForPlusCustomerQueryKey = () => {
    return [`/v1/clinician-api/check-in`] as const;
    }

    
export const getCheckInControllerGetCheckInsForPlusCustomerQueryOptions = <TData = Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckInControllerGetCheckInsForPlusCustomerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>> = ({ signal }) => checkInControllerGetCheckInsForPlusCustomer(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckInControllerGetCheckInsForPlusCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>>
export type CheckInControllerGetCheckInsForPlusCustomerQueryError = ErrorType<void>



export function useCheckInControllerGetCheckInsForPlusCustomer<TData = Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkInControllerGetCheckInsForPlusCustomer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckInControllerGetCheckInsForPlusCustomerQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const onboardingControllerValidateEmail = (
    validateEmailDto: ValidateEmailDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/onboarding/validate-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateEmailDto, signal
    },
      );
    }
  


export const getOnboardingControllerValidateEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingControllerValidateEmail>>, TError,{data: ValidateEmailDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof onboardingControllerValidateEmail>>, TError,{data: ValidateEmailDto}, TContext> => {

const mutationKey = ['onboardingControllerValidateEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingControllerValidateEmail>>, {data: ValidateEmailDto}> = (props) => {
          const {data} = props ?? {};

          return  onboardingControllerValidateEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingControllerValidateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerValidateEmail>>>
    export type OnboardingControllerValidateEmailMutationBody = ValidateEmailDto
    export type OnboardingControllerValidateEmailMutationError = ErrorType<unknown>

    export const useOnboardingControllerValidateEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingControllerValidateEmail>>, TError,{data: ValidateEmailDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof onboardingControllerValidateEmail>>,
        TError,
        {data: ValidateEmailDto},
        TContext
      > => {

      const mutationOptions = getOnboardingControllerValidateEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const onboardingControllerSubmitSurveyResponse = (
    onboardingSurveyDto: OnboardingSurveyDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<unknown>(
      {url: `/v1/clinician-api/onboarding/survey`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: onboardingSurveyDto, signal
    },
      );
    }
  


export const getOnboardingControllerSubmitSurveyResponseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingControllerSubmitSurveyResponse>>, TError,{data: OnboardingSurveyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof onboardingControllerSubmitSurveyResponse>>, TError,{data: OnboardingSurveyDto}, TContext> => {

const mutationKey = ['onboardingControllerSubmitSurveyResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingControllerSubmitSurveyResponse>>, {data: OnboardingSurveyDto}> = (props) => {
          const {data} = props ?? {};

          return  onboardingControllerSubmitSurveyResponse(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingControllerSubmitSurveyResponseMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerSubmitSurveyResponse>>>
    export type OnboardingControllerSubmitSurveyResponseMutationBody = OnboardingSurveyDto
    export type OnboardingControllerSubmitSurveyResponseMutationError = ErrorType<void>

    export const useOnboardingControllerSubmitSurveyResponse = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingControllerSubmitSurveyResponse>>, TError,{data: OnboardingSurveyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof onboardingControllerSubmitSurveyResponse>>,
        TError,
        {data: OnboardingSurveyDto},
        TContext
      > => {

      const mutationOptions = getOnboardingControllerSubmitSurveyResponseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const stayOnBlueprintOfferControllerAccept = (
    offerId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/stay-on-blueprint-offer/${offerId}/accept`, method: 'POST', signal
    },
      );
    }
  


export const getStayOnBlueprintOfferControllerAcceptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stayOnBlueprintOfferControllerAccept>>, TError,{offerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof stayOnBlueprintOfferControllerAccept>>, TError,{offerId: string}, TContext> => {

const mutationKey = ['stayOnBlueprintOfferControllerAccept'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stayOnBlueprintOfferControllerAccept>>, {offerId: string}> = (props) => {
          const {offerId} = props ?? {};

          return  stayOnBlueprintOfferControllerAccept(offerId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StayOnBlueprintOfferControllerAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof stayOnBlueprintOfferControllerAccept>>>
    
    export type StayOnBlueprintOfferControllerAcceptMutationError = ErrorType<unknown>

    export const useStayOnBlueprintOfferControllerAccept = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stayOnBlueprintOfferControllerAccept>>, TError,{offerId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof stayOnBlueprintOfferControllerAccept>>,
        TError,
        {offerId: string},
        TContext
      > => {

      const mutationOptions = getStayOnBlueprintOfferControllerAcceptMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const reminderControllerSetReminder = (
    setReminderDto: SetReminderDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<unknown>(
      {url: `/v1/clinician-api/reminder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setReminderDto, signal
    },
      );
    }
  


export const getReminderControllerSetReminderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reminderControllerSetReminder>>, TError,{data: SetReminderDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reminderControllerSetReminder>>, TError,{data: SetReminderDto}, TContext> => {

const mutationKey = ['reminderControllerSetReminder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reminderControllerSetReminder>>, {data: SetReminderDto}> = (props) => {
          const {data} = props ?? {};

          return  reminderControllerSetReminder(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReminderControllerSetReminderMutationResult = NonNullable<Awaited<ReturnType<typeof reminderControllerSetReminder>>>
    export type ReminderControllerSetReminderMutationBody = SetReminderDto
    export type ReminderControllerSetReminderMutationError = ErrorType<void>

    export const useReminderControllerSetReminder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reminderControllerSetReminder>>, TError,{data: SetReminderDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof reminderControllerSetReminder>>,
        TError,
        {data: SetReminderDto},
        TContext
      > => {

      const mutationOptions = getReminderControllerSetReminderMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const reminderControllerGetReminder = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<SetReminderDto>(
      {url: `/v1/clinician-api/reminder`, method: 'GET', signal
    },
      );
    }
  

export const getReminderControllerGetReminderQueryKey = () => {
    return [`/v1/clinician-api/reminder`] as const;
    }

    
export const getReminderControllerGetReminderQueryOptions = <TData = Awaited<ReturnType<typeof reminderControllerGetReminder>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reminderControllerGetReminder>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReminderControllerGetReminderQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reminderControllerGetReminder>>> = ({ signal }) => reminderControllerGetReminder(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reminderControllerGetReminder>>, TError, TData> & { queryKey: QueryKey }
}

export type ReminderControllerGetReminderQueryResult = NonNullable<Awaited<ReturnType<typeof reminderControllerGetReminder>>>
export type ReminderControllerGetReminderQueryError = ErrorType<void>



export function useReminderControllerGetReminder<TData = Awaited<ReturnType<typeof reminderControllerGetReminder>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof reminderControllerGetReminder>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getReminderControllerGetReminderQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const reminderControllerDeleteReminder = (
    
 ) => {
      
      
      return hellojoyApiInstance<unknown>(
      {url: `/v1/clinician-api/reminder`, method: 'DELETE'
    },
      );
    }
  


export const getReminderControllerDeleteReminderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reminderControllerDeleteReminder>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reminderControllerDeleteReminder>>, TError,void, TContext> => {

const mutationKey = ['reminderControllerDeleteReminder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reminderControllerDeleteReminder>>, void> = () => {
          

          return  reminderControllerDeleteReminder()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReminderControllerDeleteReminderMutationResult = NonNullable<Awaited<ReturnType<typeof reminderControllerDeleteReminder>>>
    
    export type ReminderControllerDeleteReminderMutationError = ErrorType<void>

    export const useReminderControllerDeleteReminder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reminderControllerDeleteReminder>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof reminderControllerDeleteReminder>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getReminderControllerDeleteReminderMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const progressNoteTemplateMemoryControllerDelete = (
    id: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/progress-note-template-memory/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getProgressNoteTemplateMemoryControllerDeleteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerDelete>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['progressNoteTemplateMemoryControllerDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  progressNoteTemplateMemoryControllerDelete(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProgressNoteTemplateMemoryControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerDelete>>>
    
    export type ProgressNoteTemplateMemoryControllerDeleteMutationError = ErrorType<void>

    export const useProgressNoteTemplateMemoryControllerDelete = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerDelete>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getProgressNoteTemplateMemoryControllerDeleteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const progressNoteTemplateMemoryControllerClear = (
    clearTemplateMemoryDto: ClearTemplateMemoryDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/progress-note-template-memory/clear`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clearTemplateMemoryDto, signal
    },
      );
    }
  


export const getProgressNoteTemplateMemoryControllerClearMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerClear>>, TError,{data: ClearTemplateMemoryDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerClear>>, TError,{data: ClearTemplateMemoryDto}, TContext> => {

const mutationKey = ['progressNoteTemplateMemoryControllerClear'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerClear>>, {data: ClearTemplateMemoryDto}> = (props) => {
          const {data} = props ?? {};

          return  progressNoteTemplateMemoryControllerClear(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProgressNoteTemplateMemoryControllerClearMutationResult = NonNullable<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerClear>>>
    export type ProgressNoteTemplateMemoryControllerClearMutationBody = ClearTemplateMemoryDto
    export type ProgressNoteTemplateMemoryControllerClearMutationError = ErrorType<void>

    export const useProgressNoteTemplateMemoryControllerClear = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerClear>>, TError,{data: ClearTemplateMemoryDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerClear>>,
        TError,
        {data: ClearTemplateMemoryDto},
        TContext
      > => {

      const mutationOptions = getProgressNoteTemplateMemoryControllerClearMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const progressNoteTemplateMemoryControllerFindByNoteType = (
    params: ProgressNoteTemplateMemoryControllerFindByNoteTypeParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ProgressNoteTemplateMemoryResponseDto[]>(
      {url: `/v1/clinician-api/progress-note-template-memory`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getProgressNoteTemplateMemoryControllerFindByNoteTypeQueryKey = (params: ProgressNoteTemplateMemoryControllerFindByNoteTypeParams,) => {
    return [`/v1/clinician-api/progress-note-template-memory`, ...(params ? [params]: [])] as const;
    }

    
export const getProgressNoteTemplateMemoryControllerFindByNoteTypeQueryOptions = <TData = Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>, TError = ErrorType<void>>(params: ProgressNoteTemplateMemoryControllerFindByNoteTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProgressNoteTemplateMemoryControllerFindByNoteTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>> = ({ signal }) => progressNoteTemplateMemoryControllerFindByNoteType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>, TError, TData> & { queryKey: QueryKey }
}

export type ProgressNoteTemplateMemoryControllerFindByNoteTypeQueryResult = NonNullable<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>>
export type ProgressNoteTemplateMemoryControllerFindByNoteTypeQueryError = ErrorType<void>



export function useProgressNoteTemplateMemoryControllerFindByNoteType<TData = Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>, TError = ErrorType<void>>(
 params: ProgressNoteTemplateMemoryControllerFindByNoteTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof progressNoteTemplateMemoryControllerFindByNoteType>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getProgressNoteTemplateMemoryControllerFindByNoteTypeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get the operator agent for the current clinician's organization
 */
export const operatorAgentControllerFind = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/operator-agent`, method: 'GET', signal
    },
      );
    }
  

export const getOperatorAgentControllerFindQueryKey = () => {
    return [`/v1/clinician-api/operator-agent`] as const;
    }

    
export const getOperatorAgentControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof operatorAgentControllerFind>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operatorAgentControllerFind>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperatorAgentControllerFindQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operatorAgentControllerFind>>> = ({ signal }) => operatorAgentControllerFind(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operatorAgentControllerFind>>, TError, TData> & { queryKey: QueryKey }
}

export type OperatorAgentControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof operatorAgentControllerFind>>>
export type OperatorAgentControllerFindQueryError = ErrorType<void>


/**
 * @summary Get the operator agent for the current clinician's organization
 */

export function useOperatorAgentControllerFind<TData = Awaited<ReturnType<typeof operatorAgentControllerFind>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operatorAgentControllerFind>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getOperatorAgentControllerFindQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new operator agent for the current clinician's organization
 */
export const operatorAgentControllerCreate = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/operator-agent`, method: 'POST', signal
    },
      );
    }
  


export const getOperatorAgentControllerCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatorAgentControllerCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof operatorAgentControllerCreate>>, TError,void, TContext> => {

const mutationKey = ['operatorAgentControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatorAgentControllerCreate>>, void> = () => {
          

          return  operatorAgentControllerCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperatorAgentControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof operatorAgentControllerCreate>>>
    
    export type OperatorAgentControllerCreateMutationError = ErrorType<void>

    /**
 * @summary Create a new operator agent for the current clinician's organization
 */
export const useOperatorAgentControllerCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operatorAgentControllerCreate>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof operatorAgentControllerCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getOperatorAgentControllerCreateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const growsurfControllerSendInviteEmail = (
    inviteEmailBodyDTO: InviteEmailBodyDTO,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/growsurf/invite-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteEmailBodyDTO, signal
    },
      );
    }
  


export const getGrowsurfControllerSendInviteEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerSendInviteEmail>>, TError,{data: InviteEmailBodyDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerSendInviteEmail>>, TError,{data: InviteEmailBodyDTO}, TContext> => {

const mutationKey = ['growsurfControllerSendInviteEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof growsurfControllerSendInviteEmail>>, {data: InviteEmailBodyDTO}> = (props) => {
          const {data} = props ?? {};

          return  growsurfControllerSendInviteEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GrowsurfControllerSendInviteEmailMutationResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerSendInviteEmail>>>
    export type GrowsurfControllerSendInviteEmailMutationBody = InviteEmailBodyDTO
    export type GrowsurfControllerSendInviteEmailMutationError = ErrorType<void>

    export const useGrowsurfControllerSendInviteEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerSendInviteEmail>>, TError,{data: InviteEmailBodyDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof growsurfControllerSendInviteEmail>>,
        TError,
        {data: InviteEmailBodyDTO},
        TContext
      > => {

      const mutationOptions = getGrowsurfControllerSendInviteEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const growsurfControllerGetInviteStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<InviteStatusResponseDTO>(
      {url: `/v1/clinician-api/growsurf/invite-status`, method: 'GET', signal
    },
      );
    }
  

export const getGrowsurfControllerGetInviteStatusQueryKey = () => {
    return [`/v1/clinician-api/growsurf/invite-status`] as const;
    }

    
export const getGrowsurfControllerGetInviteStatusQueryOptions = <TData = Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGrowsurfControllerGetInviteStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>> = ({ signal }) => growsurfControllerGetInviteStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GrowsurfControllerGetInviteStatusQueryResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>>
export type GrowsurfControllerGetInviteStatusQueryError = ErrorType<void>



export function useGrowsurfControllerGetInviteStatus<TData = Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetInviteStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGrowsurfControllerGetInviteStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const growsurfControllerGetInviteLink = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<InviteLinkResponseDTO>(
      {url: `/v1/clinician-api/growsurf/invite-link`, method: 'GET', signal
    },
      );
    }
  

export const getGrowsurfControllerGetInviteLinkQueryKey = () => {
    return [`/v1/clinician-api/growsurf/invite-link`] as const;
    }

    
export const getGrowsurfControllerGetInviteLinkQueryOptions = <TData = Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGrowsurfControllerGetInviteLinkQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>> = ({ signal }) => growsurfControllerGetInviteLink(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>, TError, TData> & { queryKey: QueryKey }
}

export type GrowsurfControllerGetInviteLinkQueryResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>>
export type GrowsurfControllerGetInviteLinkQueryError = ErrorType<void>



export function useGrowsurfControllerGetInviteLink<TData = Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetInviteLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGrowsurfControllerGetInviteLinkQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const growsurfControllerGetTierStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ReferralTierStatusResponseDTO>(
      {url: `/v1/clinician-api/growsurf/tier-status`, method: 'GET', signal
    },
      );
    }
  

export const getGrowsurfControllerGetTierStatusQueryKey = () => {
    return [`/v1/clinician-api/growsurf/tier-status`] as const;
    }

    
export const getGrowsurfControllerGetTierStatusQueryOptions = <TData = Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGrowsurfControllerGetTierStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>> = ({ signal }) => growsurfControllerGetTierStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GrowsurfControllerGetTierStatusQueryResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>>
export type GrowsurfControllerGetTierStatusQueryError = ErrorType<void>



export function useGrowsurfControllerGetTierStatus<TData = Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetTierStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGrowsurfControllerGetTierStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const growsurfControllerGetRewardStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ReferralRewardStatusResponseDTO>(
      {url: `/v1/clinician-api/growsurf/reward-status`, method: 'GET', signal
    },
      );
    }
  

export const getGrowsurfControllerGetRewardStatusQueryKey = () => {
    return [`/v1/clinician-api/growsurf/reward-status`] as const;
    }

    
export const getGrowsurfControllerGetRewardStatusQueryOptions = <TData = Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGrowsurfControllerGetRewardStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>> = ({ signal }) => growsurfControllerGetRewardStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GrowsurfControllerGetRewardStatusQueryResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>>
export type GrowsurfControllerGetRewardStatusQueryError = ErrorType<void>



export function useGrowsurfControllerGetRewardStatus<TData = Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetRewardStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGrowsurfControllerGetRewardStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const growsurfControllerGetUnseenRewards = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<UnseenReferralRewardResponseDTO>(
      {url: `/v1/clinician-api/growsurf/unseen-rewards`, method: 'GET', signal
    },
      );
    }
  

export const getGrowsurfControllerGetUnseenRewardsQueryKey = () => {
    return [`/v1/clinician-api/growsurf/unseen-rewards`] as const;
    }

    
export const getGrowsurfControllerGetUnseenRewardsQueryOptions = <TData = Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGrowsurfControllerGetUnseenRewardsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>> = ({ signal }) => growsurfControllerGetUnseenRewards(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>, TError, TData> & { queryKey: QueryKey }
}

export type GrowsurfControllerGetUnseenRewardsQueryResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>>
export type GrowsurfControllerGetUnseenRewardsQueryError = ErrorType<void>



export function useGrowsurfControllerGetUnseenRewards<TData = Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof growsurfControllerGetUnseenRewards>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGrowsurfControllerGetUnseenRewardsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const growsurfControllerMarkRewardsAsSeen = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/growsurf/mark-rewards-as-seen`, method: 'POST', signal
    },
      );
    }
  


export const getGrowsurfControllerMarkRewardsAsSeenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerMarkRewardsAsSeen>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerMarkRewardsAsSeen>>, TError,void, TContext> => {

const mutationKey = ['growsurfControllerMarkRewardsAsSeen'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof growsurfControllerMarkRewardsAsSeen>>, void> = () => {
          

          return  growsurfControllerMarkRewardsAsSeen()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GrowsurfControllerMarkRewardsAsSeenMutationResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerMarkRewardsAsSeen>>>
    
    export type GrowsurfControllerMarkRewardsAsSeenMutationError = ErrorType<void>

    export const useGrowsurfControllerMarkRewardsAsSeen = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerMarkRewardsAsSeen>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof growsurfControllerMarkRewardsAsSeen>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getGrowsurfControllerMarkRewardsAsSeenMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const growsurfControllerMarkUpdatesAsSeen = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/growsurf/mark-updates-as-seen`, method: 'POST', signal
    },
      );
    }
  


export const getGrowsurfControllerMarkUpdatesAsSeenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerMarkUpdatesAsSeen>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerMarkUpdatesAsSeen>>, TError,void, TContext> => {

const mutationKey = ['growsurfControllerMarkUpdatesAsSeen'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof growsurfControllerMarkUpdatesAsSeen>>, void> = () => {
          

          return  growsurfControllerMarkUpdatesAsSeen()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GrowsurfControllerMarkUpdatesAsSeenMutationResult = NonNullable<Awaited<ReturnType<typeof growsurfControllerMarkUpdatesAsSeen>>>
    
    export type GrowsurfControllerMarkUpdatesAsSeenMutationError = ErrorType<void>

    export const useGrowsurfControllerMarkUpdatesAsSeen = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof growsurfControllerMarkUpdatesAsSeen>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof growsurfControllerMarkUpdatesAsSeen>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getGrowsurfControllerMarkUpdatesAsSeenMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianSchedulingControllerGetClinicianSchedule = (
    params: ClinicianSchedulingControllerGetClinicianScheduleParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ScheduleResponseDto>(
      {url: `/v1/clinician-api/schedule`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicianSchedulingControllerGetClinicianScheduleQueryKey = (params: ClinicianSchedulingControllerGetClinicianScheduleParams,) => {
    return [`/v1/clinician-api/schedule`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicianSchedulingControllerGetClinicianScheduleQueryOptions = <TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>, TError = ErrorType<void>>(params: ClinicianSchedulingControllerGetClinicianScheduleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianSchedulingControllerGetClinicianScheduleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>> = ({ signal }) => clinicianSchedulingControllerGetClinicianSchedule(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianSchedulingControllerGetClinicianScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>>
export type ClinicianSchedulingControllerGetClinicianScheduleQueryError = ErrorType<void>



export function useClinicianSchedulingControllerGetClinicianSchedule<TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>, TError = ErrorType<void>>(
 params: ClinicianSchedulingControllerGetClinicianScheduleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetClinicianSchedule>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianSchedulingControllerGetClinicianScheduleQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianSchedulingControllerCreateAppointment = (
    createAppointmentWithNotificationDto: CreateAppointmentWithNotificationDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<AppointmentDto>(
      {url: `/v1/clinician-api/schedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAppointmentWithNotificationDto, signal
    },
      );
    }
  


export const getClinicianSchedulingControllerCreateAppointmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateAppointment>>, TError,{data: CreateAppointmentWithNotificationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateAppointment>>, TError,{data: CreateAppointmentWithNotificationDto}, TContext> => {

const mutationKey = ['clinicianSchedulingControllerCreateAppointment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateAppointment>>, {data: CreateAppointmentWithNotificationDto}> = (props) => {
          const {data} = props ?? {};

          return  clinicianSchedulingControllerCreateAppointment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianSchedulingControllerCreateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateAppointment>>>
    export type ClinicianSchedulingControllerCreateAppointmentMutationBody = CreateAppointmentWithNotificationDto
    export type ClinicianSchedulingControllerCreateAppointmentMutationError = ErrorType<void>

    export const useClinicianSchedulingControllerCreateAppointment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateAppointment>>, TError,{data: CreateAppointmentWithNotificationDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianSchedulingControllerCreateAppointment>>,
        TError,
        {data: CreateAppointmentWithNotificationDto},
        TContext
      > => {

      const mutationOptions = getClinicianSchedulingControllerCreateAppointmentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianSchedulingControllerGetCalendars = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<CalendarResponseDto[]>(
      {url: `/v1/clinician-api/schedule/calendars`, method: 'GET', signal
    },
      );
    }
  

export const getClinicianSchedulingControllerGetCalendarsQueryKey = () => {
    return [`/v1/clinician-api/schedule/calendars`] as const;
    }

    
export const getClinicianSchedulingControllerGetCalendarsQueryOptions = <TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianSchedulingControllerGetCalendarsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>> = ({ signal }) => clinicianSchedulingControllerGetCalendars(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianSchedulingControllerGetCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>>
export type ClinicianSchedulingControllerGetCalendarsQueryError = ErrorType<void>



export function useClinicianSchedulingControllerGetCalendars<TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetCalendars>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianSchedulingControllerGetCalendarsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianSchedulingControllerGetExternalCalendars = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ExternalCalendarResponseDto[]>(
      {url: `/v1/clinician-api/schedule/external-calendars`, method: 'GET', signal
    },
      );
    }
  

export const getClinicianSchedulingControllerGetExternalCalendarsQueryKey = () => {
    return [`/v1/clinician-api/schedule/external-calendars`] as const;
    }

    
export const getClinicianSchedulingControllerGetExternalCalendarsQueryOptions = <TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianSchedulingControllerGetExternalCalendarsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>> = ({ signal }) => clinicianSchedulingControllerGetExternalCalendars(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianSchedulingControllerGetExternalCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>>
export type ClinicianSchedulingControllerGetExternalCalendarsQueryError = ErrorType<void>



export function useClinicianSchedulingControllerGetExternalCalendars<TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetExternalCalendars>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianSchedulingControllerGetExternalCalendarsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianSchedulingControllerGetNextAppointmentDate = (
    clientId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<NextAppointmentDateResponseDto>(
      {url: `/v1/clinician-api/schedule/${clientId}/next-appointment-date`, method: 'GET', signal
    },
      );
    }
  

export const getClinicianSchedulingControllerGetNextAppointmentDateQueryKey = (clientId: string,) => {
    return [`/v1/clinician-api/schedule/${clientId}/next-appointment-date`] as const;
    }

    
export const getClinicianSchedulingControllerGetNextAppointmentDateQueryOptions = <TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>, TError = ErrorType<void>>(clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianSchedulingControllerGetNextAppointmentDateQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>> = ({ signal }) => clinicianSchedulingControllerGetNextAppointmentDate(clientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianSchedulingControllerGetNextAppointmentDateQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>>
export type ClinicianSchedulingControllerGetNextAppointmentDateQueryError = ErrorType<void>



export function useClinicianSchedulingControllerGetNextAppointmentDate<TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>, TError = ErrorType<void>>(
 clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetNextAppointmentDate>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianSchedulingControllerGetNextAppointmentDateQueryOptions(clientId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianSchedulingControllerUpdateAppointment = (
    eventId: string,
    updateAppointmentWithNotificationDto: UpdateAppointmentWithNotificationDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/schedule/${eventId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAppointmentWithNotificationDto
    },
      );
    }
  


export const getClinicianSchedulingControllerUpdateAppointmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerUpdateAppointment>>, TError,{eventId: string;data: UpdateAppointmentWithNotificationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerUpdateAppointment>>, TError,{eventId: string;data: UpdateAppointmentWithNotificationDto}, TContext> => {

const mutationKey = ['clinicianSchedulingControllerUpdateAppointment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerUpdateAppointment>>, {eventId: string;data: UpdateAppointmentWithNotificationDto}> = (props) => {
          const {eventId,data} = props ?? {};

          return  clinicianSchedulingControllerUpdateAppointment(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianSchedulingControllerUpdateAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerUpdateAppointment>>>
    export type ClinicianSchedulingControllerUpdateAppointmentMutationBody = UpdateAppointmentWithNotificationDto
    export type ClinicianSchedulingControllerUpdateAppointmentMutationError = ErrorType<void>

    export const useClinicianSchedulingControllerUpdateAppointment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerUpdateAppointment>>, TError,{eventId: string;data: UpdateAppointmentWithNotificationDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianSchedulingControllerUpdateAppointment>>,
        TError,
        {eventId: string;data: UpdateAppointmentWithNotificationDto},
        TContext
      > => {

      const mutationOptions = getClinicianSchedulingControllerUpdateAppointmentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianSchedulingControllerDeleteAppointment = (
    eventId: string,
    cancelAppointmentDto: CancelAppointmentDto,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/schedule/${eventId}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cancelAppointmentDto
    },
      );
    }
  


export const getClinicianSchedulingControllerDeleteAppointmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteAppointment>>, TError,{eventId: string;data: CancelAppointmentDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteAppointment>>, TError,{eventId: string;data: CancelAppointmentDto}, TContext> => {

const mutationKey = ['clinicianSchedulingControllerDeleteAppointment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteAppointment>>, {eventId: string;data: CancelAppointmentDto}> = (props) => {
          const {eventId,data} = props ?? {};

          return  clinicianSchedulingControllerDeleteAppointment(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianSchedulingControllerDeleteAppointmentMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteAppointment>>>
    export type ClinicianSchedulingControllerDeleteAppointmentMutationBody = CancelAppointmentDto
    export type ClinicianSchedulingControllerDeleteAppointmentMutationError = ErrorType<void>

    export const useClinicianSchedulingControllerDeleteAppointment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteAppointment>>, TError,{eventId: string;data: CancelAppointmentDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteAppointment>>,
        TError,
        {eventId: string;data: CancelAppointmentDto},
        TContext
      > => {

      const mutationOptions = getClinicianSchedulingControllerDeleteAppointmentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianSchedulingControllerCreateExternalCalendar = (
    externalCalendarDto: ExternalCalendarDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/schedule/external-calendar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalCalendarDto, signal
    },
      );
    }
  


export const getClinicianSchedulingControllerCreateExternalCalendarMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateExternalCalendar>>, TError,{data: ExternalCalendarDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateExternalCalendar>>, TError,{data: ExternalCalendarDto}, TContext> => {

const mutationKey = ['clinicianSchedulingControllerCreateExternalCalendar'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateExternalCalendar>>, {data: ExternalCalendarDto}> = (props) => {
          const {data} = props ?? {};

          return  clinicianSchedulingControllerCreateExternalCalendar(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianSchedulingControllerCreateExternalCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateExternalCalendar>>>
    export type ClinicianSchedulingControllerCreateExternalCalendarMutationBody = ExternalCalendarDto
    export type ClinicianSchedulingControllerCreateExternalCalendarMutationError = ErrorType<void>

    export const useClinicianSchedulingControllerCreateExternalCalendar = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerCreateExternalCalendar>>, TError,{data: ExternalCalendarDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianSchedulingControllerCreateExternalCalendar>>,
        TError,
        {data: ExternalCalendarDto},
        TContext
      > => {

      const mutationOptions = getClinicianSchedulingControllerCreateExternalCalendarMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianSchedulingControllerDeleteExternalCalendar = (
    externalCalendarId: string,
 ) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/schedule/external-calendar/${externalCalendarId}`, method: 'DELETE'
    },
      );
    }
  


export const getClinicianSchedulingControllerDeleteExternalCalendarMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteExternalCalendar>>, TError,{externalCalendarId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteExternalCalendar>>, TError,{externalCalendarId: string}, TContext> => {

const mutationKey = ['clinicianSchedulingControllerDeleteExternalCalendar'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteExternalCalendar>>, {externalCalendarId: string}> = (props) => {
          const {externalCalendarId} = props ?? {};

          return  clinicianSchedulingControllerDeleteExternalCalendar(externalCalendarId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianSchedulingControllerDeleteExternalCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteExternalCalendar>>>
    
    export type ClinicianSchedulingControllerDeleteExternalCalendarMutationError = ErrorType<void>

    export const useClinicianSchedulingControllerDeleteExternalCalendar = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteExternalCalendar>>, TError,{externalCalendarId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianSchedulingControllerDeleteExternalCalendar>>,
        TError,
        {externalCalendarId: string},
        TContext
      > => {

      const mutationOptions = getClinicianSchedulingControllerDeleteExternalCalendarMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianSchedulingControllerGetAddNewSuggestions = (
    params: ClinicianSchedulingControllerGetAddNewSuggestionsParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<AddNewSearchResponseDto>(
      {url: `/v1/clinician-api/schedule/add-new-suggestions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getClinicianSchedulingControllerGetAddNewSuggestionsQueryKey = (params: ClinicianSchedulingControllerGetAddNewSuggestionsParams,) => {
    return [`/v1/clinician-api/schedule/add-new-suggestions`, ...(params ? [params]: [])] as const;
    }

    
export const getClinicianSchedulingControllerGetAddNewSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>, TError = ErrorType<void>>(params: ClinicianSchedulingControllerGetAddNewSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianSchedulingControllerGetAddNewSuggestionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>> = ({ signal }) => clinicianSchedulingControllerGetAddNewSuggestions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianSchedulingControllerGetAddNewSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>>
export type ClinicianSchedulingControllerGetAddNewSuggestionsQueryError = ErrorType<void>



export function useClinicianSchedulingControllerGetAddNewSuggestions<TData = Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>, TError = ErrorType<void>>(
 params: ClinicianSchedulingControllerGetAddNewSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianSchedulingControllerGetAddNewSuggestions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianSchedulingControllerGetAddNewSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const icsCalendarLinkControllerGetIcsCalendarLink = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<IcsCalendarLinkResponseDto>(
      {url: `/v1/clinician-api/schedule/ics-calendar-link`, method: 'GET', signal
    },
      );
    }
  

export const getIcsCalendarLinkControllerGetIcsCalendarLinkQueryKey = () => {
    return [`/v1/clinician-api/schedule/ics-calendar-link`] as const;
    }

    
export const getIcsCalendarLinkControllerGetIcsCalendarLinkQueryOptions = <TData = Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIcsCalendarLinkControllerGetIcsCalendarLinkQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>> = ({ signal }) => icsCalendarLinkControllerGetIcsCalendarLink(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>, TError, TData> & { queryKey: QueryKey }
}

export type IcsCalendarLinkControllerGetIcsCalendarLinkQueryResult = NonNullable<Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>>
export type IcsCalendarLinkControllerGetIcsCalendarLinkQueryError = ErrorType<void>



export function useIcsCalendarLinkControllerGetIcsCalendarLink<TData = Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof icsCalendarLinkControllerGetIcsCalendarLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getIcsCalendarLinkControllerGetIcsCalendarLinkQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const icsCalendarLinkControllerCreateIcsCalendarLink = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/schedule/ics-calendar-link`, method: 'POST', signal
    },
      );
    }
  


export const getIcsCalendarLinkControllerCreateIcsCalendarLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof icsCalendarLinkControllerCreateIcsCalendarLink>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof icsCalendarLinkControllerCreateIcsCalendarLink>>, TError,void, TContext> => {

const mutationKey = ['icsCalendarLinkControllerCreateIcsCalendarLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof icsCalendarLinkControllerCreateIcsCalendarLink>>, void> = () => {
          

          return  icsCalendarLinkControllerCreateIcsCalendarLink()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IcsCalendarLinkControllerCreateIcsCalendarLinkMutationResult = NonNullable<Awaited<ReturnType<typeof icsCalendarLinkControllerCreateIcsCalendarLink>>>
    
    export type IcsCalendarLinkControllerCreateIcsCalendarLinkMutationError = ErrorType<void>

    export const useIcsCalendarLinkControllerCreateIcsCalendarLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof icsCalendarLinkControllerCreateIcsCalendarLink>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof icsCalendarLinkControllerCreateIcsCalendarLink>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getIcsCalendarLinkControllerCreateIcsCalendarLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Upload a file
 */
export const uploadControllerV1UploadFile = (
    uploadFileBodyDto: UploadFileBodyDto,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`categoryCode`, uploadFileBodyDto.categoryCode)
formData.append(`file`, uploadFileBodyDto.file)

      return hellojoyApiInstance<void>(
      {url: `/v1/clinician-api/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadControllerV1UploadFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadControllerV1UploadFile>>, TError,{data: UploadFileBodyDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadControllerV1UploadFile>>, TError,{data: UploadFileBodyDto}, TContext> => {

const mutationKey = ['uploadControllerV1UploadFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadControllerV1UploadFile>>, {data: UploadFileBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  uploadControllerV1UploadFile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadControllerV1UploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadControllerV1UploadFile>>>
    export type UploadControllerV1UploadFileMutationBody = UploadFileBodyDto
    export type UploadControllerV1UploadFileMutationError = ErrorType<void>

    /**
 * @summary Upload a file
 */
export const useUploadControllerV1UploadFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadControllerV1UploadFile>>, TError,{data: UploadFileBodyDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadControllerV1UploadFile>>,
        TError,
        {data: UploadFileBodyDto},
        TContext
      > => {

      const mutationOptions = getUploadControllerV1UploadFileMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const serviceTypeControllerFindAll = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ServiceTypesResponse>(
      {url: `/v1/clinician-api/service-type`, method: 'GET', signal
    },
      );
    }
  

export const getServiceTypeControllerFindAllQueryKey = () => {
    return [`/v1/clinician-api/service-type`] as const;
    }

    
export const getServiceTypeControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof serviceTypeControllerFindAll>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof serviceTypeControllerFindAll>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServiceTypeControllerFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof serviceTypeControllerFindAll>>> = ({ signal }) => serviceTypeControllerFindAll(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof serviceTypeControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type ServiceTypeControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof serviceTypeControllerFindAll>>>
export type ServiceTypeControllerFindAllQueryError = ErrorType<void>



export function useServiceTypeControllerFindAll<TData = Awaited<ReturnType<typeof serviceTypeControllerFindAll>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof serviceTypeControllerFindAll>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getServiceTypeControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const serviceTypeControllerGetDefaultServiceType = (
    params: ServiceTypeControllerGetDefaultServiceTypeParams,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<DefaultServiceTypeResponse>(
      {url: `/v1/clinician-api/service-type/default-service-type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getServiceTypeControllerGetDefaultServiceTypeQueryKey = (params: ServiceTypeControllerGetDefaultServiceTypeParams,) => {
    return [`/v1/clinician-api/service-type/default-service-type`, ...(params ? [params]: [])] as const;
    }

    
export const getServiceTypeControllerGetDefaultServiceTypeQueryOptions = <TData = Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>, TError = ErrorType<void>>(params: ServiceTypeControllerGetDefaultServiceTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServiceTypeControllerGetDefaultServiceTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>> = ({ signal }) => serviceTypeControllerGetDefaultServiceType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>, TError, TData> & { queryKey: QueryKey }
}

export type ServiceTypeControllerGetDefaultServiceTypeQueryResult = NonNullable<Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>>
export type ServiceTypeControllerGetDefaultServiceTypeQueryError = ErrorType<void>



export function useServiceTypeControllerGetDefaultServiceType<TData = Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>, TError = ErrorType<void>>(
 params: ServiceTypeControllerGetDefaultServiceTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof serviceTypeControllerGetDefaultServiceType>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getServiceTypeControllerGetDefaultServiceTypeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianLicenseControllerCreateLicense = (
    createClinicianLicenseDto: CreateClinicianLicenseDto,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicianLicenseDto>(
      {url: `/v1/clinician-api/license`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClinicianLicenseDto, signal
    },
      );
    }
  


export const getClinicianLicenseControllerCreateLicenseMutationOptions = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerCreateLicense>>, TError,{data: CreateClinicianLicenseDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerCreateLicense>>, TError,{data: CreateClinicianLicenseDto}, TContext> => {

const mutationKey = ['clinicianLicenseControllerCreateLicense'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianLicenseControllerCreateLicense>>, {data: CreateClinicianLicenseDto}> = (props) => {
          const {data} = props ?? {};

          return  clinicianLicenseControllerCreateLicense(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianLicenseControllerCreateLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianLicenseControllerCreateLicense>>>
    export type ClinicianLicenseControllerCreateLicenseMutationBody = CreateClinicianLicenseDto
    export type ClinicianLicenseControllerCreateLicenseMutationError = ErrorType<ApiExceptionDto>

    export const useClinicianLicenseControllerCreateLicense = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerCreateLicense>>, TError,{data: CreateClinicianLicenseDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianLicenseControllerCreateLicense>>,
        TError,
        {data: CreateClinicianLicenseDto},
        TContext
      > => {

      const mutationOptions = getClinicianLicenseControllerCreateLicenseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianLicenseControllerGetLicenses = (
    
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicianLicenseListDto>(
      {url: `/v1/clinician-api/license`, method: 'GET', signal
    },
      );
    }
  

export const getClinicianLicenseControllerGetLicensesQueryKey = () => {
    return [`/v1/clinician-api/license`] as const;
    }

    
export const getClinicianLicenseControllerGetLicensesQueryOptions = <TData = Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>, TError = ErrorType<ApiExceptionDto>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianLicenseControllerGetLicensesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>> = ({ signal }) => clinicianLicenseControllerGetLicenses(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianLicenseControllerGetLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>>
export type ClinicianLicenseControllerGetLicensesQueryError = ErrorType<ApiExceptionDto>



export function useClinicianLicenseControllerGetLicenses<TData = Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>, TError = ErrorType<ApiExceptionDto>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicenses>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianLicenseControllerGetLicensesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianLicenseControllerGetLicense = (
    licenseId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<ClinicianLicenseDto>(
      {url: `/v1/clinician-api/license/${licenseId}`, method: 'GET', signal
    },
      );
    }
  

export const getClinicianLicenseControllerGetLicenseQueryKey = (licenseId: string,) => {
    return [`/v1/clinician-api/license/${licenseId}`] as const;
    }

    
export const getClinicianLicenseControllerGetLicenseQueryOptions = <TData = Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>, TError = ErrorType<ApiExceptionDto>>(licenseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicianLicenseControllerGetLicenseQueryKey(licenseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>> = ({ signal }) => clinicianLicenseControllerGetLicense(licenseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(licenseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>, TError, TData> & { queryKey: QueryKey }
}

export type ClinicianLicenseControllerGetLicenseQueryResult = NonNullable<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>>
export type ClinicianLicenseControllerGetLicenseQueryError = ErrorType<ApiExceptionDto>



export function useClinicianLicenseControllerGetLicense<TData = Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>, TError = ErrorType<ApiExceptionDto>>(
 licenseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clinicianLicenseControllerGetLicense>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getClinicianLicenseControllerGetLicenseQueryOptions(licenseId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clinicianLicenseControllerUpdateLicense = (
    licenseId: string,
    updateClinicianLicenseDto: UpdateClinicianLicenseDto,
 ) => {
      
      
      return hellojoyApiInstance<ClinicianLicenseDto>(
      {url: `/v1/clinician-api/license/${licenseId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClinicianLicenseDto
    },
      );
    }
  


export const getClinicianLicenseControllerUpdateLicenseMutationOptions = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerUpdateLicense>>, TError,{licenseId: string;data: UpdateClinicianLicenseDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerUpdateLicense>>, TError,{licenseId: string;data: UpdateClinicianLicenseDto}, TContext> => {

const mutationKey = ['clinicianLicenseControllerUpdateLicense'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianLicenseControllerUpdateLicense>>, {licenseId: string;data: UpdateClinicianLicenseDto}> = (props) => {
          const {licenseId,data} = props ?? {};

          return  clinicianLicenseControllerUpdateLicense(licenseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianLicenseControllerUpdateLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianLicenseControllerUpdateLicense>>>
    export type ClinicianLicenseControllerUpdateLicenseMutationBody = UpdateClinicianLicenseDto
    export type ClinicianLicenseControllerUpdateLicenseMutationError = ErrorType<ApiExceptionDto>

    export const useClinicianLicenseControllerUpdateLicense = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerUpdateLicense>>, TError,{licenseId: string;data: UpdateClinicianLicenseDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianLicenseControllerUpdateLicense>>,
        TError,
        {licenseId: string;data: UpdateClinicianLicenseDto},
        TContext
      > => {

      const mutationOptions = getClinicianLicenseControllerUpdateLicenseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const clinicianLicenseControllerDeleteLicense = (
    licenseId: string,
 ) => {
      
      
      return hellojoyApiInstance<unknown>(
      {url: `/v1/clinician-api/license/${licenseId}`, method: 'DELETE'
    },
      );
    }
  


export const getClinicianLicenseControllerDeleteLicenseMutationOptions = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerDeleteLicense>>, TError,{licenseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerDeleteLicense>>, TError,{licenseId: string}, TContext> => {

const mutationKey = ['clinicianLicenseControllerDeleteLicense'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicianLicenseControllerDeleteLicense>>, {licenseId: string}> = (props) => {
          const {licenseId} = props ?? {};

          return  clinicianLicenseControllerDeleteLicense(licenseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClinicianLicenseControllerDeleteLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof clinicianLicenseControllerDeleteLicense>>>
    
    export type ClinicianLicenseControllerDeleteLicenseMutationError = ErrorType<ApiExceptionDto>

    export const useClinicianLicenseControllerDeleteLicense = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicianLicenseControllerDeleteLicense>>, TError,{licenseId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof clinicianLicenseControllerDeleteLicense>>,
        TError,
        {licenseId: string},
        TContext
      > => {

      const mutationOptions = getClinicianLicenseControllerDeleteLicenseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const invoiceControllerFindById = (
    invoiceId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<InvoiceDto>(
      {url: `/v1/clinician-api/patient-billing/invoice/${invoiceId}`, method: 'GET', signal
    },
      );
    }
  

export const getInvoiceControllerFindByIdQueryKey = (invoiceId: string,) => {
    return [`/v1/clinician-api/patient-billing/invoice/${invoiceId}`] as const;
    }

    
export const getInvoiceControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof invoiceControllerFindById>>, TError = ErrorType<ApiExceptionDto>>(invoiceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof invoiceControllerFindById>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceControllerFindByIdQueryKey(invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceControllerFindById>>> = ({ signal }) => invoiceControllerFindById(invoiceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceControllerFindById>>, TError, TData> & { queryKey: QueryKey }
}

export type InvoiceControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceControllerFindById>>>
export type InvoiceControllerFindByIdQueryError = ErrorType<ApiExceptionDto>



export function useInvoiceControllerFindById<TData = Awaited<ReturnType<typeof invoiceControllerFindById>>, TError = ErrorType<ApiExceptionDto>>(
 invoiceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof invoiceControllerFindById>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInvoiceControllerFindByIdQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const invoiceControllerUpdateInvoice = (
    invoiceId: string,
    updateInvoiceDto: UpdateInvoiceDto,
 ) => {
      
      
      return hellojoyApiInstance<InvoiceDto>(
      {url: `/v1/clinician-api/patient-billing/invoice/${invoiceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateInvoiceDto
    },
      );
    }
  


export const getInvoiceControllerUpdateInvoiceMutationOptions = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceControllerUpdateInvoice>>, TError,{invoiceId: string;data: UpdateInvoiceDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invoiceControllerUpdateInvoice>>, TError,{invoiceId: string;data: UpdateInvoiceDto}, TContext> => {

const mutationKey = ['invoiceControllerUpdateInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invoiceControllerUpdateInvoice>>, {invoiceId: string;data: UpdateInvoiceDto}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  invoiceControllerUpdateInvoice(invoiceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvoiceControllerUpdateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof invoiceControllerUpdateInvoice>>>
    export type InvoiceControllerUpdateInvoiceMutationBody = UpdateInvoiceDto
    export type InvoiceControllerUpdateInvoiceMutationError = ErrorType<ApiExceptionDto>

    export const useInvoiceControllerUpdateInvoice = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceControllerUpdateInvoice>>, TError,{invoiceId: string;data: UpdateInvoiceDto}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof invoiceControllerUpdateInvoice>>,
        TError,
        {invoiceId: string;data: UpdateInvoiceDto},
        TContext
      > => {

      const mutationOptions = getInvoiceControllerUpdateInvoiceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const invoiceControllerFinalizeInvoice = (
    invoiceId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<unknown>(
      {url: `/v1/clinician-api/patient-billing/invoice/${invoiceId}/finalize`, method: 'POST', signal
    },
      );
    }
  


export const getInvoiceControllerFinalizeInvoiceMutationOptions = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceControllerFinalizeInvoice>>, TError,{invoiceId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invoiceControllerFinalizeInvoice>>, TError,{invoiceId: string}, TContext> => {

const mutationKey = ['invoiceControllerFinalizeInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invoiceControllerFinalizeInvoice>>, {invoiceId: string}> = (props) => {
          const {invoiceId} = props ?? {};

          return  invoiceControllerFinalizeInvoice(invoiceId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvoiceControllerFinalizeInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof invoiceControllerFinalizeInvoice>>>
    
    export type InvoiceControllerFinalizeInvoiceMutationError = ErrorType<ApiExceptionDto>

    export const useInvoiceControllerFinalizeInvoice = <TError = ErrorType<ApiExceptionDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invoiceControllerFinalizeInvoice>>, TError,{invoiceId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof invoiceControllerFinalizeInvoice>>,
        TError,
        {invoiceId: string},
        TContext
      > => {

      const mutationOptions = getInvoiceControllerFinalizeInvoiceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const invoiceControllerDownloadSuperbill = (
    invoiceId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<Blob>(
      {url: `/v1/clinician-api/patient-billing/invoice/${invoiceId}/superbill`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getInvoiceControllerDownloadSuperbillQueryKey = (invoiceId: string,) => {
    return [`/v1/clinician-api/patient-billing/invoice/${invoiceId}/superbill`] as const;
    }

    
export const getInvoiceControllerDownloadSuperbillQueryOptions = <TData = Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>, TError = ErrorType<ApiExceptionDto>>(invoiceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvoiceControllerDownloadSuperbillQueryKey(invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>> = ({ signal }) => invoiceControllerDownloadSuperbill(invoiceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>, TError, TData> & { queryKey: QueryKey }
}

export type InvoiceControllerDownloadSuperbillQueryResult = NonNullable<Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>>
export type InvoiceControllerDownloadSuperbillQueryError = ErrorType<ApiExceptionDto>



export function useInvoiceControllerDownloadSuperbill<TData = Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>, TError = ErrorType<ApiExceptionDto>>(
 invoiceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof invoiceControllerDownloadSuperbill>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getInvoiceControllerDownloadSuperbillQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usageBillingInvoiceControllerFindById = (
    invoiceId: string,
 signal?: AbortSignal
) => {
      
      
      return hellojoyApiInstance<StripeInvoiceDto>(
      {url: `/v1/clinician-api/usage-billing/invoice/${invoiceId}`, method: 'GET', signal
    },
      );
    }
  

export const getUsageBillingInvoiceControllerFindByIdQueryKey = (invoiceId: string,) => {
    return [`/v1/clinician-api/usage-billing/invoice/${invoiceId}`] as const;
    }

    
export const getUsageBillingInvoiceControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>, TError = ErrorType<void>>(invoiceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageBillingInvoiceControllerFindByIdQueryKey(invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>> = ({ signal }) => usageBillingInvoiceControllerFindById(invoiceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>, TError, TData> & { queryKey: QueryKey }
}

export type UsageBillingInvoiceControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>>
export type UsageBillingInvoiceControllerFindByIdQueryError = ErrorType<void>



export function useUsageBillingInvoiceControllerFindById<TData = Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>, TError = ErrorType<void>>(
 invoiceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usageBillingInvoiceControllerFindById>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsageBillingInvoiceControllerFindByIdQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




